/**
 * @license vanityconfigurator.js v1 28/12/2023
 * 
 * IdealTeam Allen W.
 */

var VanityConfig = {
    version: "v0.0.33",
    siteName: "AD",
    rounded: false,
    shopifyStorefrontAPI: "https://idealcabinetry.myshopify.com/api/2024-07/graphql.json",
    pageSize: 21,
    pageNum: 1,
    shopifyStorefrontAccessToken: "5717a2f95e342721e4e25fc123c35af1",
    loadWaiting: false,
    timerid: [],
    discountType: "Percentage",
    /**
     * @deprecated This property is deprecated and will be removed in a future version.
     * Use CollectionBundleDiscount instead.
     */
    discountAmount: "",
    CollectionBundleId: 0,
    CollectionBundleDiscount: 0,
    storeCustomerSelectedKey: `idealcabinetry-AD-vanity-configurator-selected-v1`,
    _: window._ || window.lodash,
    storeCustomerSelectedObject: {
        Version: "",
        DoorStyle: "",
        DoorStyleFirstName: "",
        DoorStyleLastName: "",
        DoorStyleFullName: "",
        DoorStyleFS30Image: "",
        DoorStyleFS84Image: "",
        DoorStyleMTK8Image: "",
        DoorStyleFS30DKDImage: "",
        ToeKickColor: "",
        DoorStyleHandle: "",
        CollectionImage: "",
        CollectionLifeStyleImage: "",
        CollectionDoorStyle: "",
        CollectionDoorFinish: "",
        CollectionColorFinish: "",
        CollectionId: 0,
        BoxMaterial: "",
        HardwareModel: "",
        HardwareImage: "",
        Countertop: "",
        CountertopMaterial: "",
        CountertopLabel: "Countertop",
        CountertopFamilyCode: "",
        CountertopImage: "",
        CabinetBackgroundImage: "",
        CountertopLowPriceImage: "",
        CountertopWithoutTops: false,
        SinkColor: "",
        SinkColorImage: "",
        SinkColorProductId: 0,
        SinkFinish: "",
        SinkSize: "",
        SinkShape: "",
        SinkShapeProductId: 0,
        SinkShapeImage: "",
        SinkNumber: 0,
        DesiredFaucetSpread: "",
        DesiredFaucetSpreadProductId: 0,
        DesiredFaucetSpreadImage: "",
        WallLocation: "",
        WallLocationAbbr: "",
        WallLocationImage: "",
        VanityWidth: "",
        VanityFillerStrip: "",
        VanityFillerStripFloat: "",
        VanityWidthImage: "",
        VanitySpecificationsHTML: "",
        IsAgree: false,
        Filters: [],
        SelectedProducts: [],
        SelectedProductCounterTop: "",
        DhNumber: ""
    },
    quickviewVideo: undefined,
    quickviewVideoPreviewImage: undefined,
    vanityWidthSource: "",
    vanityConfigValueSource: "",
    vanityOptionSource: "",
    createProductBundles: "",
    readVanityProductsSource: "",
    htmlToImageSource: "",
    showLogoConfiguredBundleImage: true,
    configurationOptions: [],
    enableHardware: true,
    showFreeShipping: true,
    enableB2BPrice: true,
    enableLoginToAccess: true,
    enableCountertopWithoutTops: false,
    enableShowPriceSetting: true,
    isVanityAdmin: true,
    showVanityPriceForNonAdmin: true,
    isLoggedIn: false,
    loginUrl: "",
    companyLocationId: "",
    init: async function () {
        this.loadWaiting = false;
        await this.getLastConfig();
    },
    getLastConfig: async function () {
        this.showWaiting();
        this.hideGetStarted();
        this.showTabs();
        this.deactiveTab();
        var selectedItems = localStorage.getItem(this.storeCustomerSelectedKey);
        if (selectedItems == null || selectedItems == undefined) {
            //this.showGetStarted();
            this.SetTop();
            this.activeDoorStyleColorsTab();
        } else {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined) {
                if (selectedItems.Version != undefined && selectedItems.Version.length > 0 && selectedItems.Version == this.version) {
                    var vanityWithoutTops = VanityConfig.enableCountertopWithoutTops && selectedItems.CountertopWithoutTops != undefined && selectedItems.CountertopWithoutTops;
                    if (selectedItems.DoorStyle != undefined && selectedItems.DoorStyle.length > 0) {
                        DoorStyleColors.getLastConfig();
                    }
                    if (selectedItems.HardwareModel != undefined && selectedItems.HardwareModel.length > 0) {
                        Hardware.getLastConfig();
                    }
                    if (selectedItems.BoxMaterial != undefined && selectedItems.BoxMaterial.length > 0) {
                        BoxMaterial.getLastConfig();
                    }
                    if ((selectedItems.Countertop != undefined && selectedItems.Countertop.length > 0) || vanityWithoutTops) {
                        SinkColor.isLoading = true;
                        Countertops.getLastConfig();
                    }
                    if (selectedItems.SinkColor != undefined && selectedItems.SinkColor.length > 0) {
                        SinkColor.isLoading = true;
                        SinkColor.getLastConfig();
                    }
                    if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0) {
                        SinkShape.getLastConfig();
                    }
                    // if (selectedItems.SinkNumber != undefined && typeof (selectedItems.SinkNumber) === 'number' && selectedItems.SinkNumber > 0) {
                    //     SinkNumber.getLastConfig();
                    // }
                    if (vanityWithoutTops) {
                        if (selectedItems.DesiredFaucetSpread != undefined && selectedItems.DesiredFaucetSpread.length > 0) {
                            FaucetSpread.getLastConfig();
                        }
                        if (selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0) {
                            WallLocation.getLastConfig();
                        }
                        if (selectedItems.VanityWidth != undefined && selectedItems.VanityWidth.length > 0) {
                            await VanityWidth.getLastConfig();
                        }
                    } else {
                        if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0 &&
                            selectedItems.DesiredFaucetSpread != undefined && selectedItems.DesiredFaucetSpread.length > 0) {
                            FaucetSpread.getLastConfig();
                        }
                        if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0 &&
                            selectedItems.DesiredFaucetSpread != undefined && selectedItems.DesiredFaucetSpread.length > 0 &&
                            selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0) {
                            WallLocation.getLastConfig();
                        }
                        if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0 &&
                            selectedItems.DesiredFaucetSpread != undefined && selectedItems.DesiredFaucetSpread.length > 0 &&
                            selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0 &&
                            selectedItems.VanityWidth != undefined && selectedItems.VanityWidth.length > 0) {
                            await VanityWidth.getLastConfig();
                        }
                    }
                } else {
                    localStorage.removeItem(this.storeCustomerSelectedKey);
                    await this.getLastConfig();
                }
            }
        }
        this.hideWaiting();
    },
    activeDoorStyleColorsTab: function () {
        if ($("#vanity-configurator-doorstylecolors-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-doorstylecolors-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#stylecolors"]').tab('show');
    },
    activeBoxMaterialTab: function () {
        if ($("#vanity-configurator-boxmaterial-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-boxmaterial-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#boxmaterial"]').tab('show');
    },
    activeHardwareTab: function () {
        if ($("#vanity-configurator-hardware-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-hardware-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#hardware"]').tab('show');
    },
    activeCountertopTab: function () {
        if ($("#vanity-configurator-countertop-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-countertop-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#countertop"]').tab('show');
    },
    activeSinkTab: function () {
        if ($("#vanity-configurator-sink-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-sink-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#sinks"]').tab('show');
    },
    activeFaucetHolesTab: function () {
        if ($("#vanity-configurator-faucetholes-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-faucetholes-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#faucetholes"]').tab('show');
    },
    activeWallLocationTab: function () {
        if ($("#vanity-configurator-walllocation-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-walllocation-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#walllocation"]').tab('show');
    },
    activeVanityWidthTab: function () {
        if ($("#vanity-configurator-vanitywidth-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-vanitywidth-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#vanitywidth"]').tab('show');
    },
    activeCabinetLayoutTab: function () {
        if ($("#vanity-configurator-cabinetlayout-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-cabinetlayout-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#cabinetlayout"]').tab('show');
    },
    activeSummaryTab: function () {
        if ($("#vanity-configurator-summary-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-summary-tab").removeClass("disabled-tab");
        }
        $('#vanity-configurator-tabs a[href="#vanitysummary"]').tab('show');
    },
    deactiveTab: function () {
        $("#vanity-configurator-tabs li").addClass("disabled-tab");
    },
    deactiveSinkTab: function () {
        if (!$("#vanity-configurator-sink-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-sink-tab").addClass("disabled-tab");
        }
    },
    deactiveFaucetHolesTab: function () {
        if (!$("#vanity-configurator-faucetholes-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-faucetholes-tab").addClass("disabled-tab");
        }
    },
    deactiveWallLocationTab: function () {
        if (!$("#vanity-configurator-walllocation-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-walllocation-tab").addClass("disabled-tab");
        }
    },
    deactiveVanityWidthTab: function () {
        if (!$("#vanity-configurator-vanitywidth-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-vanitywidth-tab").addClass("disabled-tab");
        }
    },
    deactiveCabinetLayoutTab: function () {
        if (!$("#vanity-configurator-cabinetlayout-tab").hasClass("disabled-tab")) {
            $("#vanity-configurator-cabinetlayout-tab").addClass("disabled-tab");
        }
    },
    showTabs: function () {
        $("#build-your-own-vanity").show();
        $(".build_vanity_tabs").show();
    },
    showWaiting: function (top) {
        this.loadWaiting = true;
        // $('#WaitingLoading').css('top', (top ?? 'calc(45%)'));
        $("#WaitingLoading").show();
        var currentTimerid = setTimeout(function () {
            $("#WaitingLoading").show();
        }, 100);
        this.timerid.push({ "timerid": currentTimerid });
    },
    hideWaiting: function () {
        this.loadWaiting = false;
        if (this.timerid.length > 0) {
            this.timerid.forEach((element) => {
                clearTimeout(element.timerid);
            });
        }
        this.timerid = [];
        $("#WaitingLoading").hide();
    },
    SetTop: function () {
        $("html,body").stop(true, true).animate({ scrollTop: 120 }, 500);
    },
    SetTopChoices: function () {
        var buildVanityTabsOffset = $('.build_vanity_tabs').offset()?.top || 0;

        var siteHeader = $('#SiteHeader');
        var paddingTop = 7;
        var paddingBottom = 7;

        var menuHeight = siteHeader.height() + paddingTop + paddingBottom;
        var headerHeight = buildVanityTabsOffset - menuHeight;

        const fixedMenu = $("body").find("div").hasClass("navbar-fixed-top") || false;//for THD
        if (fixedMenu) {
            headerHeight = $("#build-your-own-vanity").parent("div").height() + 4; // Adjust for fixed menu height
        }
        $("html,body").stop(true, true).animate({ scrollTop: headerHeight }, 500);
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    },
    hideGetStarted: function () {
        $("#vanity-configurator-getstarted").hide();
    },
    showGetStarted: function () {
        $("#vanity-configurator-getstarted").show();
    },
    hideAllStep: function () {
        this.hideGetStarted();
        $(".build_vanity_tabs").hide();
    },
    hideError: function () {
        $("#errorMsg").html("");
    },
    showError: function (msg) {
        $("#errorMsg").html(msg);
        // $("html,body").animate({ scrollTop: $('#build-your-own-vanity').offset().top - 52 }, 500);
    },
    toFraction: function (num) {
        var isFloat = function (n) {
            return (typeof (n) === 'number' &&
                ((n > 0 && n % 1 > 0 && n % 1 < 1) ||
                    (n < 0 && n % -1 < 0 && n % -1 > -1))
            );
        }
        var roundToPlaces = function (n, places) {
            if (!places) {
                return Math.round(n);
            } else {
                var scalar = Math.pow(10, places);
                return Math.round(n * scalar) / scalar;
            }
        }
        var primeFactors = function (n) {

            var num = Math.abs(n);
            var factors = [];
            var _factor = 2;

            while (_factor * _factor <= num) {
                if (num % _factor === 0)  // this is a factor
                {
                    factors.push(_factor);  // so keep it
                    num = num / _factor;  // and divide our search point by it
                }
                else {
                    _factor++;
                }
            }
            if (num != 1) {
                factors.push(num);
            }
            return factors;
        }
        var gcf = function (a, b) {

            var common_factors = [];
            var fa = primeFactors(a);
            var fb = primeFactors(b);
            fa.forEach(function (factor) {
                var i = fb.indexOf(factor);
                if (i >= 0) {
                    common_factors.push(factor);
                    fb.splice(i, 1);
                }
            });
            if (common_factors.length === 0)
                return 1;
            var gcf = (function () {
                var r = common_factors[0];
                var i;
                for (i = 1; i < common_factors.length; i++) {
                    r = r * common_factors[i];
                }
                return r;
            })();
            return gcf;
        }
        var numerator = 0;
        var denominator = 1;
        if (typeof (num) === 'number') {
            numerator = num;
            denominator = 1;
        } else if (typeof (num) === 'string') {
            var a, b;
            [a, b] = num.split(' ');
            if (a % 1 === 0 && b && b.match('/')) {
                return (new Fraction(a)).add(new Fraction(b));
            } else if (a && !b) {
                if (typeof (a) === 'string' && a.match('/')) {
                    var f = a.split('/');
                    numerator = f[0]; denominator = f[1];
                } else if (typeof (a) === 'string' && a.match('\.')) {
                    return ToFraction(parseFloat(a));
                } else { // just passed a whole number as a string
                    numerator = parseInt(a);
                    denominator = 1;
                }
            } else {
                return undefined; // could not parse
            }
        }
        if (isFloat(numerator)) {
            var rounded = roundToPlaces(numerator, 9);
            var scaleup = Math.pow(10, rounded.toString().split('.')[1].length);
            numerator = Math.round(numerator * scaleup); // this !!! should be a whole number
            denominator *= scaleup;
        }
        var gcf = gcf(numerator, denominator);
        numerator /= gcf;
        denominator /= gcf;
        if ((numerator < 0 && denominator < 0) || (numerator > 0 && denominator < 0)) {
            numerator *= -1;
            denominator *= -1;
        }
        var wholepart = Math.floor(numerator / denominator);
        var numerator = numerator % denominator
        var denominator = denominator;
        var result = [];
        if (wholepart != 0)
            result.push(wholepart);
        if (numerator != 0)
            result.push(numerator + '/' + denominator);
        return result.length > 0 ? result.join(' ') : 0;
    },
    integerToWords: function (num) {
        ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        return convert(num);

        function convert(num) {
            if (num == 0) return "Zero";
            else return convert_millions(num);
        }
        function convert_millions(num) {
            if (num >= 1000000) {
                return convert_millions(Math.floor(num / 1000000)) + " Million " + convert_thousands(num % 1000000);
            }
            else {
                return convert_thousands(num);
            }
        }
        function convert_thousands(num) {
            if (num >= 1000) {
                return convert_hundreds(Math.floor(num / 1000)) + " Thousand " + convert_hundreds(num % 1000);
            }
            else {
                return convert_hundreds(num);
            }
        }

        function convert_hundreds(num) {
            if (num > 99) {
                return this.ones[Math.floor(num / 100)] + " Hundred " + convert_tens(num % 100);
            }
            else {
                return convert_tens(num);
            }
        }
        function convert_tens(num) {
            if (num < 10) return this.ones[num];
            else if (num >= 10 && num < 20) return this.teens[num - 10];
            else {
                return this.tens[Math.floor(num / 10)] + " " + this.ones[num % 10];
            }
        }
    },
    getShopifyData: async function (query = '') {
        const response = await fetch(this.shopifyStorefrontAPI, {
            method: 'POST',
            mode: "cors",
            headers: {
                "X-Shopify-Storefront-Access-Token": this.shopifyStorefrontAccessToken,
                'Content-Type': 'application/graphql'
            },
            body: query
        });
        return response.json();
    },
    getDataFromApi: async function (url = '') {
        const response = await fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.json();
    },
    validationSelectionExists: async function () {
        var exists = false;
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems.Version != undefined && selectedItems.Version.length > 0 && selectedItems.Version == this.version) {
                if (selectedItems != undefined && selectedItems.DoorStyle != undefined && selectedItems.DoorStyle.length > 0) {
                    exists = true;
                }
            } else {
                localStorage.removeItem(this.storeCustomerSelectedKey);
                await this.getLastConfig();
            }
        }
        return exists;
    },
    showVanitySelectionModal: function () {
        $('#vanity-selection-modal').modal({ backdrop: 'static', show: true });
    },
    hideVanitySelectionModal: function () {
        $('#vanity-selection-modal').modal('hide');
    },
    loadingVanity: async function () {
        VanityConfig.SetTop();
        VanityConfig.showWaiting();
        $('#getstarted').bind('click', function () {
            VanityConfig.SetTopChoices();
        });
        $('#vanity-configurator-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            VanityConfig.SetTopChoices();
        });
        await VanityConfig.init();
        $('#stylecolors .image-slider')
            .hammer()
            .on('swipeleft', function (e) {
                try {
                    var currentSlider = $(this).find('> :radio:checked').prop("id");
                    var secondSlider = $(this).find(".dots").find('label[for!="' + currentSlider + '"]');
                    $(this).find('> :radio').prop("checked", false);
                    $(this).find('> :radio[id="' + secondSlider.prop("for") + '"]').prop("checked", true);
                    e.stopPropagation();
                } catch { }
            });
        $('#stylecolors .image-slider')
            .hammer()
            .on('swiperight', function (e) {
                try {
                    var currentSlider = $(this).find('> :radio:checked').prop("id");
                    var secondSlider = $(this).find(".dots").find('label[for!="' + currentSlider + '"]');
                    $(this).find('> :radio').prop("checked", false);
                    $(this).find('> :radio[id="' + secondSlider.prop("for") + '"]').prop("checked", true);
                    e.stopPropagation();
                } catch { }
            });
        VanityConfig.hideWaiting();
    },
    closeVanitySelectionModal: async function (e) {
        e.preventDefault();
        await VanityConfig.startNewDesign();
        VanityConfig.hideVanitySelectionModal();
    },
    continuePreviousSelection: async function () {
        VanityConfig.hideVanitySelectionModal();
        await VanityConfig.loadingVanity();
    },
    startNewDesign: async function () {
        VanityConfig.hideVanitySelectionModal();
        localStorage.removeItem(VanityConfig.storeCustomerSelectedKey);
        await VanityConfig.loadingVanity();
    },
    goToCart: function () {
        VanityConfig.hideVanitySelectionModal();
        window.location.href = "/cart";
    }
};

var DoorStyleColors = {
    isLoading: false,
    discountText: function (discount) {
        if (window._.isNumber(discount) && discount > 0) {
            return `<div class="left">${discount}% OFF</div>`;
        }
        return '';
    },
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var checkObjIsLi = $(obj).is("li");
        if (checkObjIsLi) {
            var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
            if (currentChecked) {
                $("#stylecolors ul li").removeClass("active");
                $("#stylecolors ul li input[type*=checkbox]").prop("checked", false);
                this.disableNextButton();
            } else {
                this.enableNextButton();
                $("#stylecolors ul li").removeClass("active");
                $("#stylecolors ul li input[type*=checkbox]").prop("checked", false);
                $(obj).addClass("active");
                $(obj).find("input[type*=checkbox]").prop("checked", true);
            }
        } else {
            var allALinks = $(obj).siblings("a").addBack();
            var currentParentLi = $(obj).closest("li");
            allALinks.removeClass("active");
            var collectionImage = $(obj).data("collection-image");
            var collectionLifeStyleImage = $(obj).data("collection-lifestyle-image");
            var collectionDoorStyle = $(obj).data("collection-doorstyle");
            var collectionDoorFinish = $(obj).data("collection-doorfinish");
            var collectionColorFinish = $(obj).data("collection-colorfinish");
            var bundleId = $(obj).data("collection-bundle-id");
            var bundleDiscount = window._.defaultTo(window._.toNumber($(obj).data("collection-bundle-discount")), 0);

            var collectionImageHTML = currentParentLi.find(".images .image-wrapper .img-product");
            var collectionLifeStyleImageHTML = currentParentLi.find(".images .image-wrapper .img_model");
            var collectionDoorStyleHTML = currentParentLi.find(".collection-doorstyle");
            var collectionDoorFinishHTML = currentParentLi.find(".collection-doorfinish");
            var collectionColorFinishHTML = currentParentLi.find(".collection-colorfinish");
            var bundleDiscountHTML = currentParentLi.find(".vanity-bundle-discount");

            if (collectionImageHTML) {
                collectionImageHTML.attr("src", collectionImage);
            }
            if (collectionLifeStyleImageHTML) {
                collectionLifeStyleImageHTML.attr("src", collectionLifeStyleImage);
            }
            if (collectionDoorStyleHTML) {
                collectionDoorStyleHTML.text(collectionDoorStyle);
            }
            if (collectionDoorFinishHTML) {
                collectionDoorFinishHTML.text(collectionDoorFinish);
            }
            if (collectionColorFinishHTML) {
                collectionColorFinishHTML.text(collectionColorFinish);
            }

            if (bundleDiscountHTML) {
                bundleDiscountHTML.html(DoorStyleColors.discountText(bundleDiscount));
            }


            var doorStyleColorCheckbox = currentParentLi.find("input[type*=checkbox]");
            var doorStyle = $(obj).data("doorstyle");
            var doorStyleFirstName = $(obj).data("doorstylefirstname");
            var doorStyleLastName = $(obj).data("doorstylelastname");
            var doorStyleFullname = $(obj).data("doorstylefullname");
            var doorStyleHandle = $(obj).data("handle");
            var doorStyleFS30Image = $(obj).data("doorstylefs30");
            var doorStyleFS84Image = $(obj).data("doorstylefs84");
            var doorStyleMTK8Image = $(obj).data("doorstylemtk8");
            var doorStyleFS30DKDImage = $(obj).data("doorstylefs30dkd");
            var toeKickColor = $(obj).data("toekickcolor");
            var collectionId = $(obj).data("collectionid");

            if (doorStyleColorCheckbox) {
                // doorStyleColorCheckbox.prop("checked", true);
                doorStyleColorCheckbox.data("doorstyle", doorStyle);
                doorStyleColorCheckbox.data("doorstylefirstname", doorStyleFirstName);
                doorStyleColorCheckbox.data("doorstylelastname", doorStyleLastName);
                doorStyleColorCheckbox.data("doorstylefullname", doorStyleFullname);
                doorStyleColorCheckbox.data("handle", doorStyleHandle);
                doorStyleColorCheckbox.data("doorstylefs30", doorStyleFS30Image);
                doorStyleColorCheckbox.data("doorstylefs84", doorStyleFS84Image);
                doorStyleColorCheckbox.data("doorstylemtk8", doorStyleMTK8Image);
                doorStyleColorCheckbox.data("doorstylefs30dkd", doorStyleFS30DKDImage);
                doorStyleColorCheckbox.data("toekickcolor", toeKickColor);
                doorStyleColorCheckbox.data("collection-image", collectionImage);
                doorStyleColorCheckbox.data("collection-lifestyle-image", collectionLifeStyleImage);
                doorStyleColorCheckbox.data("collection-doorstyle", collectionDoorStyle);
                doorStyleColorCheckbox.data("collection-doorfinish", collectionDoorFinish);
                doorStyleColorCheckbox.data("collection-colorfinish", collectionColorFinish);
                doorStyleColorCheckbox.data("collectionid", collectionId);
                doorStyleColorCheckbox.data("collection-bundle-id", bundleId);
                doorStyleColorCheckbox.data("collection-bundle-discount", bundleDiscount);
            }

            $(obj).addClass("active");
            event.stopPropagation();
        }

        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#stylecolors-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#stylecolors-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectedDoorStyle = $("#stylecolors ul li input[type*=checkbox]:checked").prop("checked");
        if (selectedDoorStyle == undefined || !selectedDoorStyle) {
            VanityConfig.showError("Please select a door style & color!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#stylecolors ul li input[type*=checkbox]:checked"));
            VanityConfig.activeDoorStyleColorsTab();
            if (VanityConfig.enableHardware) {
                VanityConfig.activeHardwareTab();
            } else {
                VanityConfig.activeBoxMaterialTab();
            }
        }
        try {
            Shopify.analytics.publish('send_custom_event', {
                name: 'vanity_form_start',
                data: {
                    referrer: document.referrer ?? '',
                    date: new Date().toString()
                }
            });
        } catch {
        }
        VanityConfig.hideWaiting();
    },
    storeCustomerSelected: function (obj) {
        var doorStyle = $(obj).data("doorstyle");
        var doorStyleFirstName = $(obj).data("doorstylefirstname");
        var doorStyleLastName = $(obj).data("doorstylelastname");
        var doorStyleFullname = $(obj).data("doorstylefullname");
        var doorStyleHandle = $(obj).data("handle");
        var doorStyleFS30Image = $(obj).data("doorstylefs30");
        var doorStyleFS84Image = $(obj).data("doorstylefs84");
        var doorStyleMTK8Image = $(obj).data("doorstylemtk8");
        var doorStyleFS30DKDImage = $(obj).data("doorstylefs30dkd");
        var toeKickColor = $(obj).data("toekickcolor");
        var collectionImage = $(obj).data("collection-image");
        var collectionLifeStyleImage = $(obj).data("collection-lifestyle-image");
        var collectionDoorStyle = $(obj).data("collection-doorstyle");
        var collectionDoorFinish = $(obj).data("collection-doorfinish");
        var collectionColorFinish = $(obj).data("collection-colorfinish");
        var collectionId = $(obj).data("collectionid");
        var bundleId = $(obj).data("collection-bundle-id");
        var bundleDiscount = window._.defaultTo(window._.toNumber($(obj).data("collection-bundle-discount")), 0);
        VanityConfig.storeCustomerSelectedObject.Version = VanityConfig.version;
        VanityConfig.storeCustomerSelectedObject.DoorStyle = doorStyle;
        VanityConfig.storeCustomerSelectedObject.DoorStyleFirstName = doorStyleFirstName;
        VanityConfig.storeCustomerSelectedObject.DoorStyleLastName = doorStyleLastName;
        VanityConfig.storeCustomerSelectedObject.DoorStyleFullName = doorStyleFullname;
        VanityConfig.storeCustomerSelectedObject.DoorStyleHandle = doorStyleHandle;
        VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image = doorStyleFS30Image;
        VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image = doorStyleFS84Image;
        VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image = doorStyleMTK8Image;
        VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage = doorStyleFS30DKDImage;
        VanityConfig.storeCustomerSelectedObject.ToeKickColor = toeKickColor;
        VanityConfig.storeCustomerSelectedObject.CollectionImage = collectionImage;
        VanityConfig.storeCustomerSelectedObject.CollectionLifeStyleImage = collectionLifeStyleImage;
        VanityConfig.storeCustomerSelectedObject.CollectionDoorStyle = collectionDoorStyle;
        VanityConfig.storeCustomerSelectedObject.CollectionDoorFinish = collectionDoorFinish;
        VanityConfig.storeCustomerSelectedObject.CollectionColorFinish = collectionColorFinish;
        VanityConfig.storeCustomerSelectedObject.CollectionId = collectionId;
        VanityConfig.CollectionBundleId = bundleId;
        VanityConfig.CollectionBundleDiscount = bundleDiscount;
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.DoorStyle != undefined && selectedItems.DoorStyle.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.DoorStyle = selectedItems.DoorStyle;
                VanityConfig.storeCustomerSelectedObject.DoorStyleFirstName = selectedItems.DoorStyleFirstName;
                VanityConfig.storeCustomerSelectedObject.DoorStyleLastName = selectedItems.DoorStyleLastName;
                VanityConfig.storeCustomerSelectedObject.DoorStyleFullName = selectedItems.DoorStyleFullName;
                VanityConfig.storeCustomerSelectedObject.DoorStyleHandle = selectedItems.DoorStyleHandle;
                VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image = selectedItems.DoorStyleFS30Image;
                VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image = selectedItems.DoorStyleFS84Image;
                VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image = selectedItems.DoorStyleMTK8Image;
                VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage = selectedItems.DoorStyleFS30DKDImage;
                VanityConfig.storeCustomerSelectedObject.ToeKickColor = selectedItems.ToeKickColor;
                VanityConfig.storeCustomerSelectedObject.CollectionImage = selectedItems.CollectionImage;
                VanityConfig.storeCustomerSelectedObject.CollectionLifeStyleImage = selectedItems.CollectionLifeStyleImage;
                VanityConfig.storeCustomerSelectedObject.CollectionDoorStyle = selectedItems.CollectionDoorStyle;
                VanityConfig.storeCustomerSelectedObject.CollectionDoorFinish = selectedItems.CollectionDoorFinish;
                VanityConfig.storeCustomerSelectedObject.CollectionColorFinish = selectedItems.CollectionColorFinish;
                VanityConfig.storeCustomerSelectedObject.CollectionId = selectedItems.CollectionId;

                $("#stylecolors ul li").removeClass("active");
                $("#stylecolors ul li input[type*=checkbox]").prop("checked", false);
                // Find the correct checkbox using data-collectionids (comma separated)
                var styleColorsCheckbox = $(`#stylecolors ul li input[type*=checkbox]`).filter(function () {
                    var ids = (String($(this).data('collectionids')) || '').split(',');
                    return ids.includes(String(VanityConfig.storeCustomerSelectedObject.CollectionId));
                })
                styleColorsCheckbox.prop("checked", "checked");
                styleColorsCheckbox.closest("li").addClass("active");


                /// Get latest bundle discount from shopify instead of cache
                var currentBundleDiscount = 0;
                var currentBundleId = 0;
                var activeColorItem = $(`#stylecolors ul li.active .vanity-collection-color-item[data-collectionid='${selectedItems.CollectionId}']`);
                if (activeColorItem.length > 0) {
                    currentBundleId = window._.defaultTo(window._.toNumber(activeColorItem.data("collection-bundle-id")), 0);
                    currentBundleDiscount = window._.defaultTo(window._.toNumber(activeColorItem.data("collection-bundle-discount")), 0);
                }
                VanityConfig.CollectionBundleDiscount = currentBundleDiscount;
                VanityConfig.CollectionBundleId = currentBundleId;

                styleColorsCheckbox.data("doorstyle", VanityConfig.storeCustomerSelectedObject.DoorStyle);
                styleColorsCheckbox.data("doorstylefirstname", VanityConfig.storeCustomerSelectedObject.DoorStyleFirstName);
                styleColorsCheckbox.data("doorstylelastname", VanityConfig.storeCustomerSelectedObject.DoorStyleLastName);
                styleColorsCheckbox.data("doorstylefullname", VanityConfig.storeCustomerSelectedObject.DoorStyleFullName);
                styleColorsCheckbox.data("handle", VanityConfig.storeCustomerSelectedObject.DoorStyleHandle);
                styleColorsCheckbox.data("doorstylefs30", VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image);
                styleColorsCheckbox.data("doorstylefs84", VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image);
                styleColorsCheckbox.data("doorstylemtk8", VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image);
                styleColorsCheckbox.data("doorstylefs30dkd", VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage);
                styleColorsCheckbox.data("toekickcolor", VanityConfig.storeCustomerSelectedObject.ToeKickColor);
                styleColorsCheckbox.data("collection-image", VanityConfig.storeCustomerSelectedObject.CollectionImage);
                styleColorsCheckbox.data("collection-lifestyle-image", VanityConfig.storeCustomerSelectedObject.CollectionLifeStyleImage);
                styleColorsCheckbox.data("collection-doorstyle", VanityConfig.storeCustomerSelectedObject.CollectionDoorStyle);
                styleColorsCheckbox.data("collection-doorfinish", VanityConfig.storeCustomerSelectedObject.CollectionDoorFinish);
                styleColorsCheckbox.data("collection-colorfinish", VanityConfig.storeCustomerSelectedObject.CollectionColorFinish);
                styleColorsCheckbox.data("collection-bundle-id", VanityConfig.CollectionBundleId);
                styleColorsCheckbox.data("collection-bundle-discount", VanityConfig.CollectionBundleDiscount);


                var collectionImageHTML = $("#stylecolors ul li.active .images .image-wrapper .img-product");
                var collectionLifeStyleImageHTML = $("#stylecolors ul li.active .images .image-wrapper .img_model");
                var collectionDoorStyleHTML = $("#stylecolors ul li.active .collection-doorstyle");
                var collectionDoorFinishHTML = $("#stylecolors ul li.active .collection-doorfinish");
                var collectionColorFinishHTML = $("#stylecolors ul li.active .collection-colorfinish");
                var bundleDiscountHTML = $("#stylecolors ul li.active .vanity-bundle-discount");
                $("#stylecolors ul li.active .vanity-collection-color-item").removeClass("active");
                $("#stylecolors ul li.active .vanity-collection-color-item[data-collectionid='" + VanityConfig.storeCustomerSelectedObject.CollectionId + "']").addClass("active");
                if (collectionImageHTML) {
                    collectionImageHTML.attr("src", VanityConfig.storeCustomerSelectedObject.CollectionImage);
                }
                if (collectionLifeStyleImageHTML) {
                    collectionLifeStyleImageHTML.attr("src", VanityConfig.storeCustomerSelectedObject.CollectionLifeStyleImage);
                }
                if (collectionDoorStyleHTML) {
                    collectionDoorStyleHTML.text(VanityConfig.storeCustomerSelectedObject.CollectionDoorStyle);
                }
                if (collectionDoorFinishHTML) {
                    collectionDoorFinishHTML.text(VanityConfig.storeCustomerSelectedObject.CollectionDoorFinish);
                }
                if (collectionColorFinishHTML) {
                    collectionColorFinishHTML.text(VanityConfig.storeCustomerSelectedObject.CollectionColorFinish);
                }

                if (bundleDiscountHTML) {
                    bundleDiscountHTML.html(DoorStyleColors.discountText(VanityConfig.CollectionBundleDiscount));
                }

            }
        }
        this.isLoading = true;
        this.nextStep();
    },
}

var Hardware = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#hardware ul li").removeClass("active");
            $("#hardware ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#hardware ul li").removeClass("active");
            $("#hardware ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#hardware-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#hardware-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();

        var selectHardware = $("#hardware ul li input[type*=checkbox]:checked").prop("checked");
        if (selectHardware == undefined || !selectHardware) {
            VanityConfig.showError("Please select a hardware!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();

            this.storeCustomerSelected($("#hardware ul li input[type*=checkbox]:checked"));
            VanityConfig.activeBoxMaterialTab();
        }

        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeDoorStyleColorsTab();
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.HardwareModel != undefined && selectedItems.HardwareModel.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.HardwareModel = selectedItems.HardwareModel;
                VanityConfig.storeCustomerSelectedObject.HardwareImage = selectedItems.HardwareImage;
                $("#hardware ul li").removeClass("active");
                $("#hardware ul li input[type*=checkbox]").prop("checked", false);
                $(`#hardware ul li input[type*=checkbox][data-hardwaremodel='${VanityConfig.storeCustomerSelectedObject.HardwareModel}']`).prop("checked", "checked");
                $(`#hardware ul li input[type*=checkbox][data-hardwaremodel='${VanityConfig.storeCustomerSelectedObject.HardwareModel}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var hardwareModel = $(obj).data("hardwaremodel");
        var hardwareImage = $(obj).data("hardwareimage");

        VanityConfig.storeCustomerSelectedObject.HardwareModel = hardwareModel;
        VanityConfig.storeCustomerSelectedObject.HardwareImage = hardwareImage;

        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    }
}

var BoxMaterial = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#boxmaterial ul li").removeClass("active");
            $("#boxmaterial ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#boxmaterial ul li").removeClass("active");
            $("#boxmaterial ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#boxmaterial-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#boxmaterial-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();

        var selectBoxMaterial = $("#boxmaterial ul li input[type*=checkbox]:checked").prop("checked");
        if (selectBoxMaterial == undefined || !selectBoxMaterial) {
            VanityConfig.showError("Please select a box material!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();

            this.storeCustomerSelected($("#boxmaterial ul li input[type*=checkbox]:checked"));
            VanityConfig.activeCountertopTab();
        }

        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeHardwareTab();
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.BoxMaterial != undefined && selectedItems.BoxMaterial.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.BoxMaterial = selectedItems.BoxMaterial;
                $("#boxmaterial ul li").removeClass("active");
                $("#boxmaterial ul li input[type*=checkbox]").prop("checked", false);
                $(`#boxmaterial ul li input[type*=checkbox][data-boxmaterial='${VanityConfig.storeCustomerSelectedObject.BoxMaterial}']`).prop("checked", "checked");
                $(`#boxmaterial ul li input[type*=checkbox][data-boxmaterial='${VanityConfig.storeCustomerSelectedObject.BoxMaterial}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var boxMaterial = $(obj).data("boxmaterial");

        VanityConfig.storeCustomerSelectedObject.BoxMaterial = boxMaterial;

        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    }
}

var Countertops = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#countertop ul li").removeClass("active");
            $("#countertop ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#countertop ul li").removeClass("active");
            $("#countertop ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        var currentCountertop = $("#countertop ul li input[type*=checkbox]:checked").data("countertop");
        if (currentCountertop != undefined && currentCountertop.length > 0
            && currentCountertop === "nocountertop"
        ) {
            $("#countertop-next").html("Next<span>: Wall Location</span>");
            $("#walllocation-back").html("Back<span>: Countertop</span>");
            $("#walllocation-back").attr("onclick", "SinkShape.prevStep();");
        } else {
            $("#countertop-next").html("Next<span>: Sink</span>");
            $("#walllocation-back").html("Back<span>: Faucet Holes</span>");
            $("#walllocation-back").attr("onclick", "WallLocation.prevStep();");
        }
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#countertop-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#countertop-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var withoutTopsStatus = false;
        if (VanityConfig.enableCountertopWithoutTops) {
            var currentCountertop = $("#countertop ul li input[type*=checkbox]:checked").data("countertop");
            withoutTopsStatus = (currentCountertop != undefined && currentCountertop.length > 0 && currentCountertop === "nocountertop");
        }

        if (withoutTopsStatus) {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#countertop ul li input[type*=checkbox]:checked"));
            VanityConfig.deactiveSinkTab();
            VanityConfig.deactiveFaucetHolesTab();
            VanityConfig.activeWallLocationTab();
            SinkShape.disableNextButton();
            $("#sinkshape ul li").removeClass("active");
            $("#sinkshape ul li input[type*=checkbox]").prop("checked", false);
            FaucetSpread.disableNextButton();
            $("#faucetspread ul li").removeClass("active");
            $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);

            $("#countertop-next").html("Next<span>: Wall Location</span>");
            $("#walllocation-back").html("Back<span>: Countertop</span>");
            $("#walllocation-back").attr("onclick", "SinkShape.prevStep();");
        } else {
            $("#countertop-next").html("Next<span>: Sink</span>");
            $("#walllocation-back").html("Back<span>: Faucet Holes</span>");
            $("#walllocation-back").attr("onclick", "WallLocation.prevStep();");
            var selectCounterTop = $("#countertop ul li input[type*=checkbox]:checked").prop("checked");
            if (selectCounterTop == undefined || !selectCounterTop) {
                VanityConfig.showError("Please select a countertop!");
            } else {
                VanityConfig.hideError();
                VanityConfig.hideGetStarted();

                var currentCountertop = $("#countertop ul li input[type*=checkbox]:checked").data("countertopmaterial");
                var quartzStatus = (currentCountertop != undefined
                    && currentCountertop.length > 0
                    && currentCountertop != VanityConfig.storeCustomerSelectedObject.CountertopMaterial);
                if (quartzStatus) {
                    VanityConfig.deactiveSinkTab();
                    VanityConfig.deactiveFaucetHolesTab();
                    VanityConfig.deactiveWallLocationTab();
                    VanityConfig.deactiveVanityWidthTab();
                    VanityConfig.deactiveCabinetLayoutTab();
                    SinkShape.disableNextButton();
                    $("#sinkshape ul li").removeClass("active");
                    $("#sinkshape ul li input[type*=checkbox]").prop("checked", false);
                    FaucetSpread.disableNextButton();
                    $("#faucetspread ul li").removeClass("active");
                    $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);
                    WallLocation.disableNextButton();
                    $("#walllocation ul li").removeClass("active");
                    $("#walllocation ul li input[type*=checkbox]").prop("checked", false);
                    VanityWidth.disableNextButton();
                    $("#txt_VanityWidth").val(0);
                    $('#ddl_Width').prop('selectedIndex', 0);
                    $("#vanitywidth ul li").removeClass("active");
                    $("#vanitywidth ul li input[type*=checkbox]").prop("checked", false);
                }

                this.storeCustomerSelected($("#countertop ul li input[type*=checkbox]:checked"));
                VanityConfig.activeSinkTab();
                SinkColor.loading();
                var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
                if (selectedItems != null || selectedItems != undefined) {
                    selectedItems = JSON.parse(selectedItems);
                    if (selectedItems != undefined && selectedItems.SinkColor != undefined && selectedItems.SinkColor.length > 0 && $("#sinkcolor ul li").length > 3) {
                        SinkColor.activeSinkColorTab();
                    }
                    if (selectedItems != undefined && selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0) {
                        SinkColor.activeSinkShapeTab();
                    }
                }
            }
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeHardwareTab();
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.Countertop != undefined && selectedItems.Countertop.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.Countertop = selectedItems.Countertop;
                VanityConfig.storeCustomerSelectedObject.CountertopFamilyCode = selectedItems.CountertopFamilyCode;
                VanityConfig.storeCustomerSelectedObject.CountertopMaterial = selectedItems.CountertopMaterial;
                VanityConfig.storeCustomerSelectedObject.CountertopImage = selectedItems.CountertopImage;
                VanityConfig.storeCustomerSelectedObject.CabinetBackgroundImage = selectedItems.CabinetBackgroundImage;
                VanityConfig.storeCustomerSelectedObject.CountertopLowPriceImage = selectedItems.CountertopLowPriceImage;
                VanityConfig.storeCustomerSelectedObject.CountertopWithoutTops = selectedItems.CountertopWithoutTops;
                $("#countertop ul li").removeClass("active");
                $("#countertop ul li input[type*=checkbox]").prop("checked", false);
                $(`#countertop ul li input[type*=checkbox][data-countertop='${VanityConfig.storeCustomerSelectedObject.Countertop}']`).prop("checked", "checked");
                $(`#countertop ul li input[type*=checkbox][data-countertop='${VanityConfig.storeCustomerSelectedObject.Countertop}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var counterTop = $(obj).data("countertop");
        var counterTopFamilyCode = $(obj).data("countertopfamilycode");
        var counterTopMaterial = $(obj).data("countertopmaterial");
        var counterTopimage = $(obj).data("countertopimage");
        var cabinetBackgroundImage = $(obj).data("cabinetbackgroundimage");
        var countertopLowPriceImage = $(obj).data("countertoplowpriceimage");
        var countertopWithoutTops = (counterTop != undefined && counterTop.length > 0 && counterTop === "nocountertop");
        VanityConfig.storeCustomerSelectedObject.CountertopWithoutTops = countertopWithoutTops;
        VanityConfig.storeCustomerSelectedObject.Countertop = counterTop;
        VanityConfig.storeCustomerSelectedObject.CountertopFamilyCode = counterTopFamilyCode;
        VanityConfig.storeCustomerSelectedObject.CountertopMaterial = counterTopMaterial;
        VanityConfig.storeCustomerSelectedObject.CountertopImage = counterTopimage;
        VanityConfig.storeCustomerSelectedObject.CabinetBackgroundImage = cabinetBackgroundImage;
        VanityConfig.storeCustomerSelectedObject.CountertopLowPriceImage = countertopLowPriceImage;
        if (countertopWithoutTops) {
            VanityConfig.storeCustomerSelectedObject.SinkColorImage = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkColorProductId = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkShape = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkShapeImage = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkShapeProductId = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkSize = undefined;
            VanityConfig.storeCustomerSelectedObject.SinkFinish = undefined;
            VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread = undefined;
            VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId = undefined;
            VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadImage = undefined;
        } else {
            var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
            if (selectedItems != null || selectedItems != undefined) {
                selectedItems = JSON.parse(selectedItems);
                if (selectedItems != undefined && (selectedItems.SinkShape == undefined || selectedItems.SinkShape.length == 0)
                    && ((selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0) ||
                        (selectedItems.VanityWidth != undefined && selectedItems.VanityWidth.length > 0))) {
                    VanityConfig.storeCustomerSelectedObject.WallLocation = "";
                    VanityConfig.storeCustomerSelectedObject.WallLocationAbbr = "";
                    VanityConfig.storeCustomerSelectedObject.WallLocationImage = "";
                    VanityConfig.storeCustomerSelectedObject.VanityWidthImage = "";
                    VanityConfig.deactiveWallLocationTab();
                    $("#walllocation ul li").removeClass("active");
                    $("#walllocation ul li input[type*=checkbox]").prop("checked", false);

                    VanityConfig.storeCustomerSelectedObject.VanityWidth = "";
                    VanityConfig.storeCustomerSelectedObject.VanityFillerStrip = "";
                    VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat = "";
                    VanityConfig.storeCustomerSelectedObject.VanityWidthImage = "";
                    VanityConfig.storeCustomerSelectedObject.Filters = [];
                    VanityConfig.deactiveVanityWidthTab();
                    $("#txt_VanityWidth").val(0);
                    $('#ddl_Width').prop('selectedIndex', 0);
                    VanityConfig.deactiveCabinetLayoutTab();
                }

                var currentCountertop = $("#countertop ul li input[type*=checkbox]:checked").data("countertopmaterial");
                var quartzStatus = (currentCountertop != undefined
                    && currentCountertop.length > 0
                    && currentCountertop != selectedItems.CountertopMaterial);
                if (quartzStatus) {
                    VanityConfig.storeCustomerSelectedObject.SinkColorImage = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkColorProductId = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkShape = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkShapeImage = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkShapeProductId = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkSize = undefined;
                    VanityConfig.storeCustomerSelectedObject.SinkFinish = undefined;
                    VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread = undefined;
                    VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId = undefined;
                    VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadImage = undefined;
                    VanityConfig.storeCustomerSelectedObject.WallLocation = "";
                    VanityConfig.storeCustomerSelectedObject.WallLocationAbbr = "";
                    VanityConfig.storeCustomerSelectedObject.WallLocationImage = "";
                    VanityConfig.storeCustomerSelectedObject.VanityWidthImage = "";
                    VanityConfig.storeCustomerSelectedObject.VanityWidth = "";
                    VanityConfig.storeCustomerSelectedObject.VanityFillerStrip = "";
                    VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat = "";
                    VanityConfig.storeCustomerSelectedObject.VanityWidthImage = "";
                    VanityConfig.storeCustomerSelectedObject.Filters = [];
                }
            }
        }
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    }
}
var SinkColor = {
    isLoading: false,
    loading: function () {
        this.deactiveTab();
        this.activeSinkColorTab();
        var sinkOption = $(`#sinkcolor ul li[data-sinkcolormaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}']`);
        this.clickable(sinkOption);
        this.activeSinkShapeTab();
        $("#sinks-tabs").hide();
        $("#sinkcolor").hide();
        $("#sinks-tabs").closest("div.tab_wrap").removeClass("tab_wrap");

    },
    deactiveTab: function () {
        $("#sinks-tabs li").addClass("disabled-tab");
    },
    activeSinkColorTab: function () {
        if ($("#sink-color-tab").hasClass("disabled-tab")) {
            $("#sink-color-tab").removeClass("disabled-tab");
        }
        $('#sinks-tabs a[href="#sinkcolor"]').tab('show');
    },
    activeSinkShapeTab: function () {
        if ($("#sink-shape-tab").hasClass("disabled-tab")) {
            $("#sink-shape-tab").removeClass("disabled-tab");
        }
        $('#sinks-tabs a[href="#sinkshape"]').tab('show');
    },
    clickable: function (obj) {
        VanityConfig.showWaiting();
        $("#sinkcolor ul li").removeClass("active");
        $("#sinkcolor ul li input[type*=checkbox]").prop("checked", false);
        $(obj).addClass("active");
        $(obj).find("input[type*=checkbox]").prop("checked", true);
        this.nextStep();
        VanityConfig.hideWaiting();
    },
    switchSinkShape: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null && selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems.SinkColor != undefined) {
                if (selectedItems.SinkColor.toLowerCase() == "bisque") {
                    $(".bisquequartz").show();
                    $(".whitequartz").hide();
                } else {
                    $(".bisquequartz").hide();
                    $(".whitequartz").show();
                }
            }
        }
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectSinkColor = $("#sinkcolor ul li input[type*=checkbox]:checked").prop("checked");
        if (selectSinkColor == undefined || !selectSinkColor) {
            VanityConfig.showError("Please select a sink color!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#sinkcolor ul li input[type*=checkbox]:checked"));
            this.switchSinkShape();
            this.activeSinkShapeTab();
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeCountertopTab();
    },
    getLastConfig: function () {
        this.loading();
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.SinkColor != undefined && selectedItems.SinkColor.length > 0) {
                VanityConfig.storeCustomerSelectedObject.SinkColor = selectedItems.SinkColor;
                VanityConfig.storeCustomerSelectedObject.SinkColorImage = selectedItems.SinkColorImage;
                VanityConfig.storeCustomerSelectedObject.SinkColorProductId = selectedItems.SinkColorProductId;
                $("#sinkcolor ul li").removeClass("active");
                $("#sinkcolor ul li input[type*=checkbox]").prop("checked", false);
                $(`#sinkcolor ul li[data-sinkcolormaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}'] input[type*=checkbox][data-sinkcolor='${VanityConfig.storeCustomerSelectedObject.SinkColor}']`).prop("checked", "checked");
                $(`#sinkcolor ul li[data-sinkcolormaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}'] input[type*=checkbox][data-sinkcolor='${VanityConfig.storeCustomerSelectedObject.SinkColor}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var sinkColor = $(obj).data("sinkcolor");
        var sinkColorImage = $(obj).data("sinkcolorimage");
        var sinkColorProductId = $(obj).data("sinkcolorproductid");
        VanityConfig.storeCustomerSelectedObject.SinkColor = sinkColor;
        VanityConfig.storeCustomerSelectedObject.SinkColorImage = sinkColorImage;
        VanityConfig.storeCustomerSelectedObject.SinkColorProductId = sinkColorProductId;
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    },
}
var SinkShape = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#sinkshape ul li").removeClass("active");
            $("#sinkshape ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#sinkshape ul li").removeClass("active");
            $("#sinkshape ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#sinks-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#sinks-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectCounterTop = $("#sinkshape ul li input[type*=checkbox]:checked").prop("checked");
        if (selectCounterTop == undefined || !selectCounterTop) {
            VanityConfig.showError("Please select a sink shape!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            // if ($("#sinkshape ul li input[type*=checkbox]:checked").data("sinkshape").toLowerCase() != VanityConfig.storeCustomerSelectedObject.SinkShape.toLocaleLowerCase()) {
            //     SinkNumber.clearSelectedItems();
            // }
            this.storeCustomerSelected($("#sinkshape ul li input[type*=checkbox]:checked"));

            VanityConfig.activeFaucetHolesTab();
            FaucetSpread.switchFaucetSpread();
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeCountertopTab();
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.SinkShape = selectedItems.SinkShape;
                VanityConfig.storeCustomerSelectedObject.SinkShapeImage = selectedItems.SinkShapeImage;
                VanityConfig.storeCustomerSelectedObject.SinkShapeProductId = selectedItems.SinkShapeProductId;
                VanityConfig.storeCustomerSelectedObject.SinkFinish = selectedItems.SinkFinish;
                VanityConfig.storeCustomerSelectedObject.SinkSize = selectedItems.SinkSize;
                $("#sinkshape ul li").removeClass("active");
                $("#sinkshape ul li input[type*=checkbox]").prop("checked", false);
                $(`#sinkshape ul li input[type*=checkbox][data-sinkcolor='${VanityConfig.storeCustomerSelectedObject.SinkColor}'][data-sinkshape='${VanityConfig.storeCustomerSelectedObject.SinkShape}']`).prop("checked", "checked");
                $(`#sinkshape ul li input[type*=checkbox][data-sinkcolor='${VanityConfig.storeCustomerSelectedObject.SinkColor}'][data-sinkshape='${VanityConfig.storeCustomerSelectedObject.SinkShape}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var sinkShape = $(obj).data("sinkshape");
        var sinkShapeProductId = $(obj).data("sinkshapeproductid");
        var sinkShapeImage = $(obj).data("sinkshapeimage");
        var sinkFinish = $(obj).data("sinkfinish");
        var sinkSize = $(obj).data("sinksize");
        VanityConfig.storeCustomerSelectedObject.SinkShape = sinkShape;
        VanityConfig.storeCustomerSelectedObject.SinkShapeImage = sinkShapeImage;
        VanityConfig.storeCustomerSelectedObject.SinkShapeProductId = sinkShapeProductId;
        VanityConfig.storeCustomerSelectedObject.SinkNumber = 1;
        VanityConfig.storeCustomerSelectedObject.SinkFinish = sinkFinish;
        VanityConfig.storeCustomerSelectedObject.SinkSize = sinkSize;

        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    }
}
var SinkNumber = {
    isLoading: false,
    loading: function () {
        this.deactiveTab();
        this.switchSinkNumber();
        this.activeSinkNumberTab();
    },
    deactiveTab: function () {
        $("#faucetholes-tabs li").addClass("disabled-tab");
    },
    activeSinkNumberTab: function () {
        if ($("#sinknumber-tab").hasClass("disabled-tab")) {
            $("#sinknumber-tab").removeClass("disabled-tab");
        }
        $('#faucetholes-tabs a[href="#numberofsinks"]').tab('show');
    },
    activeFaucetSpreadTab: function () {
        if ($("#faucetspread-tab").hasClass("disabled-tab")) {
            $("#faucetspread-tab").removeClass("disabled-tab");
        }
        $('#faucetholes-tabs a[href="#faucetspread"]').tab('show');
    },
    clickable: function (obj) {
        VanityConfig.showWaiting();
        $("#numberofsinks ul li").removeClass("active");
        $("#numberofsinks ul li input[type*=checkbox]").prop("checked", false);
        $(obj).addClass("active");
        $(obj).find("input[type*=checkbox]").prop("checked", true);
        this.nextStep();
        VanityConfig.hideWaiting();
    },
    switchSinkNumber: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null && selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0) {
                if (selectedItems.SinkShape.toLowerCase() == "oval") {
                    $("#sinknumber-single").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-oval.png?v=48407");
                    $("#sinknumber-double").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-oval.png?v=48407");
                    $("#sinknumber-single").next("label").text("Single Oval");
                    $("#sinknumber-double").next("label").text("Double Oval");
                } else {
                    $("#sinknumber-single").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-rectangle.png?v=48407");
                    $("#sinknumber-double").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-rectangle.png?v=48407");
                    $("#sinknumber-single").next("label").text("Single Rectangle");
                    $("#sinknumber-double").next("label").text("Double Rectangle");
                }
            }
        }
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectSinkNumber = $("#numberofsinks ul li input[type*=checkbox]:checked").prop("checked");
        if (selectSinkNumber == undefined || !selectSinkNumber) {
            VanityConfig.showError("Please select a sink number!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#numberofsinks ul li input[type*=checkbox]:checked"));
            this.activeFaucetSpreadTab();
            FaucetSpread.switchFaucetSpread();
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeSinkTab();
    },
    getLastConfig: function () {
        this.loading();
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.SinkNumber != undefined && typeof (selectedItems.SinkNumber) === 'number' && selectedItems.SinkNumber > 0) {
                VanityConfig.storeCustomerSelectedObject.SinkNumber = selectedItems.SinkNumber;
                $("#numberofsinks ul li").removeClass("active");
                $("#numberofsinks ul li input[type*=checkbox]").prop("checked", false);
                $(`#numberofsinks ul li input[type*=checkbox][data-sinknumber='${VanityConfig.storeCustomerSelectedObject.SinkNumber}']`).prop("checked", "checked");
                $(`#numberofsinks ul li input[type*=checkbox][data-sinknumber='${VanityConfig.storeCustomerSelectedObject.SinkNumber}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    clearSelectedItems: function () {
        VanityConfig.storeCustomerSelectedObject.SinkNumber = 0;
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread = "";
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId = 0;
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadImage = "";
        localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        $("#numberofsinks ul li").removeClass("active");
        $("#numberofsinks ul li input[type*=checkbox]").prop("checked", false);
        $("#faucetspread ul li").removeClass("active");
        $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);
    },
    storeCustomerSelected: function (obj) {
        var sinkNumber = $(obj).data("sinknumber");
        VanityConfig.storeCustomerSelectedObject.SinkNumber = sinkNumber;
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    },
}
var FaucetSpread = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#faucetspread ul li").removeClass("active");
            $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#faucetspread ul li").removeClass("active");
            $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        VanityConfig.hideWaiting();
    },
    switchFaucetSpread: function () {
        $("#faucetspread ul li").hide();
        $(`#faucetspread ul li[data-faucetspreadmaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}']`).show();
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null && selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems.SinkShape != undefined && selectedItems.SinkShape.length > 0
                && selectedItems.SinkNumber != undefined && typeof (selectedItems.SinkNumber) === 'number' && selectedItems.SinkNumber > 0) {
                if (selectedItems.SinkShape.toLowerCase() == "oval") {
                    if (selectedItems.SinkNumber == 1) {
                        $("[id$='-faucet-eightin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-oval-8.jpg?v=12662094199002279190");
                        $("[id$='-faucet-fourin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-oval-4.jpg?v=12868484007125711551");
                        $("[id$='-faucet-single']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-oval-1.jpg?v=9189482250366180729");
                    } else {
                        $("[id$='-faucet-eightin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-oval-8.png?v=48407");
                        $("[id$='-faucet-fourin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-oval-4.png?v=48407");
                        $("[id$='-faucet-single']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-oval-1.png?v=48407");
                    }
                } else {
                    if (selectedItems.SinkNumber == 1) {
                        $("[id$='-faucet-eightin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-rectangle-8.jpg?v=9503033569758031192");
                        $("[id$='-faucet-fourin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-rectangle-4.jpg?v=14259386145562630147");
                        $("[id$='-faucet-single']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/single-rectangle-1.jpg?v=5833117241911456441");
                    } else {
                        $("[id$='-faucet-eightin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-rectangle-8.png?v=48407");
                        $("[id$='-faucet-fourin']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-rectangle-4.png?v=48407");
                        $("[id$='-faucet-single']").closest("li").find("img").prop("src", "//idealcabinetry.com/cdn/shop/files/double-rectangle-1.png?v=48407");
                    }
                }
            }
        }
    },
    disableNextButton: function () {
        $("#faucetholes-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#faucetholes-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectCounterTop = $("#faucetspread ul li input[type*=checkbox]:checked").prop("checked");
        if (selectCounterTop == undefined || !selectCounterTop) {
            VanityConfig.showError("Please select a faucet spread!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#faucetspread ul li input[type*=checkbox]:checked"));

            VanityConfig.activeWallLocationTab();
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeSinkTab();
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.DesiredFaucetSpread != undefined && selectedItems.DesiredFaucetSpread.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread = selectedItems.DesiredFaucetSpread;
                VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId = selectedItems.DesiredFaucetSpreadProductId;
                VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadImage = selectedItems.DesiredFaucetSpreadImage;
                $("#faucetspread ul li").removeClass("active");
                $("#faucetspread ul li input[type*=checkbox]").prop("checked", false);
                $(`#faucetspread ul li[data-faucetspreadmaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}'] input[type*=checkbox][data-faucetspread='${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread}']`).prop("checked", "checked");
                $(`#faucetspread ul li[data-faucetspreadmaterial='${VanityConfig.storeCustomerSelectedObject.CountertopMaterial}'] input[type*=checkbox][data-faucetspread='${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
    storeCustomerSelected: function (obj) {
        var desiredFaucetSpread = $(obj).data("faucetspread");
        var desiredFaucetSpreadProductId = $(obj).data("faucetspreadproductid");
        var desiredFaucetSpreadImage = $(obj).data("faucetspreadimage");
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread = desiredFaucetSpread;
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId = desiredFaucetSpreadProductId;
        VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadImage = desiredFaucetSpreadImage;
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    }
}
var WallLocation = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        var currentChecked = $(obj).find("input[type*=checkbox]").prop("checked");
        if (currentChecked) {
            this.disableNextButton();
            $("#walllocation ul li").removeClass("active");
            $("#walllocation ul li input[type*=checkbox]").prop("checked", false);
        } else {
            this.enableNextButton();
            $("#walllocation ul li").removeClass("active");
            $("#walllocation ul li input[type*=checkbox]").prop("checked", false);
            $(obj).addClass("active");
            $(obj).find("input[type*=checkbox]").prop("checked", true);
        }
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#walllocation-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#walllocation-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var selectedWallLocation = $("#walllocation ul li input[type*=checkbox]:checked").prop("checked");
        if (selectedWallLocation == undefined || !selectedWallLocation) {
            VanityConfig.showError("Please select a wall location!");
        } else {
            VanityConfig.hideError();
            $("#widthError").hide();
            VanityConfig.hideGetStarted();
            this.storeCustomerSelected($("#walllocation ul li input[type*=checkbox]:checked"));
            VanityConfig.activeVanityWidthTab();
            if (VanityConfig.storeCustomerSelectedObject != undefined
                && VanityConfig.storeCustomerSelectedObject.WallLocation != undefined
                && VanityConfig.storeCustomerSelectedObject.WallLocation.length > 0) {
                $("#imageWidth").prop("src", VanityConfig.storeCustomerSelectedObject.VanityWidthImage);
            }
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeFaucetHolesTab();
    },
    storeCustomerSelected: function (obj) {
        var wallLocation = $(obj).data("layout");
        var wallLocationAbbr = $(obj).data("layoutabbr");
        var wallLocationImage = $(obj).data("layoutimage");
        var vanityWidthImage = $(obj).data("widthimage");
        VanityConfig.storeCustomerSelectedObject.WallLocation = wallLocation;
        VanityConfig.storeCustomerSelectedObject.WallLocationAbbr = wallLocationAbbr;
        VanityConfig.storeCustomerSelectedObject.WallLocationImage = wallLocationImage;
        VanityConfig.storeCustomerSelectedObject.VanityWidthImage = vanityWidthImage;
        if (this.isLoading == undefined || !this.isLoading)
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.isLoading = false;
    },
    getLastConfig: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.WallLocation = selectedItems.WallLocation;
                VanityConfig.storeCustomerSelectedObject.WallLocationAbbr = selectedItems.WallLocationAbbr;
                VanityConfig.storeCustomerSelectedObject.WallLocationImage = selectedItems.WallLocationImage;
                VanityConfig.storeCustomerSelectedObject.VanityWidthImage = selectedItems.VanityWidthImage;
                $("#walllocation ul li").removeClass("active");
                $("#walllocation ul li input[type*=checkbox]").prop("checked", false);
                $(`#walllocation ul li input[type*=checkbox][data-layout='${VanityConfig.storeCustomerSelectedObject.WallLocation}']`).prop("checked", "checked");
                $(`#walllocation ul li input[type*=checkbox][data-layout='${VanityConfig.storeCustomerSelectedObject.WallLocation}']`).closest("li").addClass("active");
            }
        }
        this.isLoading = true;
        this.nextStep();
    },
}
var VanityWidth = {
    isLoading: false,
    disableNextButton: function () {
        $("#vanitywidth-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#vanitywidth-next").removeClass("disabled");
    },
    nextStep: async function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        var vanityWidth = $("#txt_VanityWidth").val();
        if (vanityWidth == undefined || parseFloat(vanityWidth) <= 0) {
            VanityConfig.showError("Please enter a valid vanity width!");
        } else {
            VanityConfig.hideError();
            VanityConfig.hideGetStarted();
            $("#widthError").hide();
            var validCabinetWidth = await this.findCabinetWidth();
            if (validCabinetWidth) {
                this.storeCustomerSelected();
                VanityConfig.pageNum = 1;
                await ConfigurationOptions.cabinetConfigurations();
                VanityConfig.activeCabinetLayoutTab();
            } else {
                VanityConfig.storeCustomerSelectedObject.VanityWidth = "";
                VanityConfig.storeCustomerSelectedObject.VanityFillerStrip = "";
                VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat = "";
                VanityConfig.storeCustomerSelectedObject.VanityWidthImage = "";
                VanityConfig.storeCustomerSelectedObject.Filters = [];
                localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
            }
        }
        this.isLoading = false;
        try {
            Shopify.analytics.publish('send_custom_event', {
                name: 'vanity_form_submit',
                data: {
                    referrer: document.referrer ?? '',
                    date: new Date().toString()
                }
            });
        } catch {
        }
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeWallLocationTab();
    },
    storeCustomerSelected: function () {
        var vanityWidth = $("#txt_VanityWidth").val();
        var vanityFillerStrip = $("#ddl_Width option:selected").text();
        var vanityFillerStripFloat = $("#ddl_Width option:selected").val();
        var vanityWidthImage = $("#imageWidth").prop("src");
        VanityConfig.storeCustomerSelectedObject.VanityWidth = vanityWidth;
        VanityConfig.storeCustomerSelectedObject.VanityFillerStrip = vanityFillerStrip;
        VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat = vanityFillerStripFloat;
        VanityConfig.storeCustomerSelectedObject.VanityWidthImage = vanityWidthImage;
        VanityConfig.storeCustomerSelectedObject.Filters = [];
        if (this.isLoading == undefined || !this.isLoading) {
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
            this.postWidthToGoogle();
        }
        this.isLoading = false;
    },
    getLastConfig: async function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0) {
                this.enableNextButton();
                VanityConfig.storeCustomerSelectedObject.VanityWidth = selectedItems.VanityWidth;
                VanityConfig.storeCustomerSelectedObject.VanityFillerStrip = selectedItems.VanityFillerStrip;
                VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat = selectedItems.VanityFillerStripFloat;
                VanityConfig.storeCustomerSelectedObject.VanityWidthImage = selectedItems.VanityWidthImage;
                VanityConfig.storeCustomerSelectedObject.Filters = selectedItems.Filters;
                $("#txt_VanityWidth").val(VanityConfig.storeCustomerSelectedObject.VanityWidth);
                $(`#ddl_Width`).prop("selected", false);
                $(`#ddl_Width option:contains('${VanityConfig.storeCustomerSelectedObject.VanityFillerStrip}')`).prop("selected", true);
                $("#imageWidth").prop("src", VanityConfig.storeCustomerSelectedObject.VanityWidthImage);
            }
        }
        this.isLoading = true;
        await this.nextStep();
    },
    findCabinetWidth: async function () {
        var vanityWidth = $("#txt_VanityWidth").val();
        var vanityFillerStrip = $("#ddl_Width option:selected").val();
        vanityWidth = parseFloat(vanityWidth) + parseFloat(vanityFillerStrip);
        var wallAbbr = VanityConfig.storeCustomerSelectedObject.WallLocationAbbr;
        var findwidth = 0;
        var vanityWidthFromApi = await VanityConfig.getDataFromApi(`${VanityConfig.vanityWidthSource}?wall=${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}&width=${vanityWidth}`).catch((error) => {
            console.log(error);
        });
        var currentwidth = window._.toNumber((vanityWidthFromApi?.Data[0] || [])?.currentwidth ?? 0);
        var prewidth = window._.toNumber((vanityWidthFromApi?.Data[0] || [])?.prewidth ?? 0);
        var nextwidth = window._.toNumber((vanityWidthFromApi?.Data[0] || [])?.nextwidth ?? 0);

        var errorWidthHTML = "";
        var nextWidthHTML = "";
        var preWidthHTML = "";
        if (currentwidth > 0) {
            findwidth = currentwidth;
        } else {
            if (prewidth > 0) {
                preWidthHTML = `
                <input type="button" id="btnChangePreWidth" class="final_cartbtn"
                   style="color:#ffffff; font-size:14px; margin-top:5px; font-weight:bold;margin-left: 10px;"
                   value='Click to use ${VanityConfig.toFraction(prewidth)}"' onclick="VanityWidth.availableWidths(${prewidth})" />`;
            }
            if (nextwidth > 0) {
                nextWidthHTML = `
                <input type="button" id="btnChangeNextWidth" class="final_cartbtn"
                   style="color:#ffffff; font-size:14px; margin-top:5px; font-weight:bold;margin-left: 10px;"
                   value='Click to use ${VanityConfig.toFraction(nextwidth)}"' onclick="VanityWidth.availableWidths(${nextwidth})" />`;
            }
            errorWidthHTML = `
        <div class="Error_body">
              <div style="color:#f00; font-weight:bold; font-size:14px; padding:5px 10px;">
                SIZE NOT AVAILABLE.<br>
                Please select a size below.<br>
              </div>
                ${preWidthHTML}
                ${nextWidthHTML}
            </div>`;
        }

        if (!window._.isEmpty(errorWidthHTML) && vanityWidth != findwidth) {
            VanityConfig.SetTopChoices();
            $("#widthError").html(errorWidthHTML);
            $("#widthError").show();
            return false;
        } else {
            var configurationOptions = await VanityConfig.getDataFromApi(`${VanityConfig.vanityConfigValueSource}?doorstyle=${VanityConfig.storeCustomerSelectedObject.DoorStyle}&wall=${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}&width=${vanityWidth}`).catch((error) => {
                console.log(error);
            });
            VanityConfig.configurationOptions = await ConfigurationOptions.cabinetConfigurationOptionsIncludedPriceV2(configurationOptions.Data);

            if (VanityConfig.configurationOptions.length <= 0) {
                VanityConfig.SetTopChoices();
                VanityConfig.showError("No vanity configurations exist for width entered. Please re-enter width and try again.");
                $("#vanity-configurator-cabinetlayout-tab").addClass("disabled-tab");
                return false;
            }

            return true;
        }
    },
    availableWidths: function (width) {
        var widthString = (VanityConfig.toFraction(width) ?? 0).split(' ');
        var widthInt = widthString[0] ?? 0;
        var widthFraction = widthString[1] ?? 0;
        $("#txt_VanityWidth").val(widthInt);
        $(`#ddl_Width`).prop("selected", false);
        $(`#ddl_Width option:contains('${widthFraction}')`).prop("selected", true);
        $("#widthError").hide();
    },
    detection: function () {
        var a = $("#txt_VanityWidth").val();
        if (a == 0) {
            $("#txt_VanityWidth").val('');
        }
        if (a == '') {
            $("#txt_VanityWidth").val(0);
        }
        if (a > 0) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    },
    plus: function () {
        var txtvanity = $("#txt_VanityWidth");
        var vWidth = parseInt(txtvanity.val());
        if (isNaN(vWidth)) {
            alert('Error! You must enter a number for desired width.');
        }
        else {
            var newQuantity = vWidth + 1;
            $(txtvanity).prop("value", newQuantity);
        }
        if (txtvanity.val() > 0) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    },
    minus: function () {
        var txtvanity = $("#txt_VanityWidth");
        var vWidth = parseInt(txtvanity.val());
        if (isNaN(vWidth)) {
            alert('Error! You must enter a number for desired width.');
        }
        else {
            var newQuantity = (vWidth - 1) < 1 ? 0 : vWidth - 1;
            $(txtvanity).prop("value", newQuantity);
        }
        if (txtvanity.val() > 0) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    },
    postWidthToGoogle: function () {
        var selectedItems = localStorage.getItem(VanityConfig.storeCustomerSelectedKey);
        if (selectedItems != null || selectedItems != undefined) {
            selectedItems = JSON.parse(selectedItems);
            if (selectedItems != undefined && selectedItems.WallLocation != undefined && selectedItems.WallLocation.length > 0 && Shopify.analytics != null) {
                var _wall_type = selectedItems?.WallLocationAbbr ?? '';
                var _width = parseInt(selectedItems?.VanityWidth ?? 0) + parseFloat(selectedItems?.VanityFillerStripFloat ?? 0.00);
                if (isNaN(_width)) _width = 0.00;
                var _push_data = { 'wallType': _wall_type, 'width': _width };
                try {
                    Shopify.analytics.publish('vanity_measurements', { data: _push_data });
                } catch { }
            }
        }
    },
}
var ConfigurationOptions = {
    isLoading: false,
    clickable: function (obj) {
        VanityConfig.showWaiting();
        VanityConfig.hideWaiting();
    },
    disableNextButton: function () {
        $("#cabinetlayout-next").addClass("disabled");
    },
    enableNextButton: function () {
        $("#cabinetlayout-next").removeClass("disabled");
    },
    nextStep: function () {
        VanityConfig.showWaiting();
        VanityConfig.SetTopChoices();
        VanityConfig.hideWaiting();
    },
    prevStep: function () {
        VanityConfig.activeVanityWidthTab();
    },
    storeCustomerSelected: function (obj) {

    },
    getLastConfig: function () {

    },
    sortChange: async function (target) {
        var currentSelectedSorting = $(target).find("option:selected").first().text();
        $(`.configuration-options-sorting`).prop("selected", false);
        $(`.configuration-options-sorting option:contains('${currentSelectedSorting}')`).prop("selected", true);

        VanityConfig.showWaiting();
        VanityConfig.pageNum = 1;
        VanityConfig.SetTopChoices();
        await this.cabinetConfigurations();
        $("#cabinets-filters").addClass("hidden-cabinet-layout-filters");
        $("#cabinets-filters").removeClass("cabinet-layout-filters");
        document.querySelector("body").style.removeProperty("overflow");
        document.querySelector("#cabinets-filters").style.removeProperty("overflow");
        document.querySelector("#left-filters-menus").style.removeProperty("overflow");
        document.querySelector("#left-filters-menus").style.removeProperty("height");
        VanityConfig.hideWaiting();
    },
    getCabinetSideSkins: function (cabinets, wall, material, color) {
        const sortedCabinets = _.sortBy(cabinets, 'display');

        if (_.isEqual(material.toUpperCase(), "PLY") ||
            color.toUpperCase().includes("WHITE")) {
            return _.map(sortedCabinets, (cab) => ({ ...cab, left: false, right: false }));
        }

        const cabinetCount = sortedCabinets.length;

        const cabinetSides = _.map(sortedCabinets, (cab, i) => ({ ...cab, left: false, right: false }));

        const isTall = (i) => { return sortedCabinets[i].istall; };

        const isDesk = (i) => { return /^DKD30/i.test(sortedCabinets[i].model); };

        const lastCabinetIndex = cabinetCount - 1;

        if (wall === 'L') {
            if (!isTall(lastCabinetIndex) && !isDesk(lastCabinetIndex)) cabinetSides[lastCabinetIndex].right = true;
            if (isTall(lastCabinetIndex)) cabinetSides[lastCabinetIndex].left = cabinetSides[lastCabinetIndex].right = true;
            if (isTall(0)) cabinetSides[0].right = true;
        } else if (wall === 'R') {
            if (!isTall(0) && !isDesk(0)) cabinetSides[0].left = true;
            if (isTall(0)) cabinetSides[0].left = cabinetSides[0].right = true;
            if (isTall(lastCabinetIndex)) cabinetSides[lastCabinetIndex].left = true;
        } else if (wall === 'B') {
            if (isTall(0)) cabinetSides[0].right = true;
            if (isTall(lastCabinetIndex)) cabinetSides[lastCabinetIndex].left = true;
        } else if (wall === 'N') {
            if (isTall(0)) cabinetSides[0].left = cabinetSides[0].right = true;
            if (!isTall(0) && !isDesk(0)) cabinetSides[0].left = true;
            if (isTall(lastCabinetIndex)) cabinetSides[lastCabinetIndex].left = cabinetSides[lastCabinetIndex].right = true;
            if (!isTall(lastCabinetIndex) && !isDesk(lastCabinetIndex)) cabinetSides[lastCabinetIndex].right = true;
        }

        if (cabinetCount - 1 > 1) {
            _.forEach(_.range(1, cabinetCount - 1), i => {
                if (isTall(i)) {
                    cabinetSides[i].left = true;
                    cabinetSides[i].right = true;
                }
            });
        }

        _.forEach(_.range(cabinetCount), i => {
            if (isDesk(i)) {
                const prevCabinet = i - 1;

                const nextCabinet = i + 1;
                if (prevCabinet >= 0) cabinetSides[prevCabinet].right = true;
                if (nextCabinet <= lastCabinetIndex) cabinetSides[nextCabinet].left = true;
            }
        });

        return cabinetSides;
    },
    cabinetConfigurationOptionsIncludedPriceV2: async function (source) {
        if (((source || [])?.length ?? 0) === 0) return [];

        var vanityConfigValueOptions = [];
        var sortVanityConfigValues = source.toSorted((a, b) => {
            if (b.displayorder !== a.displayorder) {
                return b.displayorder - a.displayorder;
            }
            return String(a.configid).localeCompare(String(b.configid));
        });
        // var groupVanityConfigValues = Array.from(Map.groupBy(sortVanityConfigValues, ({ configid }) => configid));
        var groupVanityConfigValues = window._.groupBy(sortVanityConfigValues, v => `${v.configid}|${v.LeftFiller ?? 0}|${v.RightFiller ?? 0}|${v.LeftOverhang ?? 0}|${v.RightOverhang ?? 0}`);
        var groupProductModel = Array.from(Map.groupBy(sortVanityConfigValues, ({ model }) => model));

        if (!window._.isEmpty(groupVanityConfigValues)) {
            var shopifyFilterBody = [];
            shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: "FS30" } });
            shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: "FS84" } });
            shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: "MTK8" } });
            shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: VanityConfig.storeCustomerSelectedObject.HardwareModel } });
            shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: "HDWE Template" } });

            groupProductModel.forEach(([key, value]) => {
                var getModel = key;
                if (getModel != undefined) {
                    shopifyFilterBody.push({ productMetafield: { namespace: "custom", key: "vanitymodel", value: getModel } });
                }
            });

            var filterCountertopsArr = [
                `(title:${VanityConfig.storeCustomerSelectedObject.CountertopFamilyCode}*)`
            ];

            if (!VanityConfig.enableCountertopWithoutTops || !VanityConfig.storeCustomerSelectedObject.CountertopWithoutTops) {
                filterCountertopsArr.push(
                    `(id:${VanityConfig.storeCustomerSelectedObject.SinkColorProductId})`,
                    `(id:${VanityConfig.storeCustomerSelectedObject.SinkShapeProductId})`,
                    `(id:${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId})`);

                if (VanityConfig.storeCustomerSelectedObject.CountertopMaterial.toLowerCase() == "quartz") {
                    filterCountertopsArr.push(
                        `(title:PC-ENDSPLASH)`,
                        `(title:PC-PolishCut)`);
                } else {
                    filterCountertopsArr.push(
                        `(title:CL-ENDSPLASH)`,
                        `(title:CL-PolishCut)`);
                }
            }
            var filterCountertops = filterCountertopsArr.join(' OR ');

            var productsQuery = `
                products(first: 100, query: "${filterCountertops}") {
                    edges {
                      node {
                        id
                        title
                        description
                        productType
                        metafields(
                          identifiers: [{namespace: "custom", key: "vanitymodel"},{namespace: "custom", key: "numdoors"},{namespace: "custom", key: "numdrawers"}, {namespace: "custom", key: "vanityimage"}, {namespace: "custom", key: "vanitydkdimage"}, {namespace: "custom", key: "vanity_product_description"},{ namespace: "custom", key: "min_width" },{ namespace: "custom", key: "max_width" }]
                        ) {
                          key
                          value
                          reference {
                            ... on MediaImage {
                              image {
                                src
                                originalSrc
                              }
                            }
                          }
                        }
                        variants(first: 10) {
                            nodes {
                                id
                                price {
                                amount
                                }
                                metafields(
                                identifiers: [
                                    { namespace: "custom", key: "side" }
                                    { namespace: "custom", key: "material" }
                                ]
                                ) {
                                key
                                value
                                reference {
                                    ... on MediaImage {
                                    image {
                                        src
                                        originalSrc
                                    }
                                    }
                                }
                                }
                            }
                        }
                      }
                    }
                }
                `;
            var query = `query Products($filters: [ProductFilter!] = ${JSON.stringify(shopifyFilterBody).replace(/"(\w+)"\s*:/g, '$1:')}) {
                    collection(handle: "${VanityConfig.storeCustomerSelectedObject.DoorStyleHandle}") {
                      handle
                      products(first: 250, filters: $filters) {
                        edges {
                          node {
                            id
                            title
                            description
                            metafields(
                              identifiers: [{namespace: "custom", key: "vanitymodel"},{namespace: "custom", key: "numdoors"},{namespace: "custom", key: "numdrawers"}, {namespace: "custom", key: "vanityimage"}, {namespace: "custom", key: "vanitydkdimage"}, {namespace: "custom", key: "vanity_product_description"}]
                            ) {
                              key
                              value
                              reference {
                                ... on MediaImage {
                                  image {
                                    src
                                    originalSrc
                                  }
                                }
                              }
                            }
                            variants(first: 10) {
                                nodes {
                                    id
                                    price {
                                    amount
                                    }
                                    metafields(
                                    identifiers: [
                                        { namespace: "custom", key: "side" }
                                        { namespace: "custom", key: "material" }
                                    ]
                                    ) {
                                    key
                                    value
                                    reference {
                                        ... on MediaImage {
                                        image {
                                            src
                                            originalSrc
                                        }
                                        }
                                    }
                                    }
                                }
                            }
                          }
                        }
                      }
                    }
                    ${productsQuery}
                  }`;
            var shopifyProducts = [];
            var shopifyData = await VanityConfig.getShopifyData(query);
            if (shopifyData != undefined && shopifyData.data.collection.products != undefined) {
                shopifyData.data.collection.products.edges.forEach((element) => {
                    const currentProduct =
                    {
                        ProductId: element.node.id,
                        Name: element.node.title,
                        Description: element.node.metafields.filter(m => m != undefined && m.key == "vanity_product_description")[0]?.value ?? element.node.description,
                        Model: element.node.metafields.filter(m => m != undefined && m.key == "vanitymodel")[0]?.value ?? "",
                        NumDoors: element.node.metafields.filter(m => m != undefined && m.key == "numdoors")[0]?.value ?? 0,
                        NumDrawers: element.node.metafields.filter(m => m != undefined && m.key == "numdrawers")[0]?.value ?? 0,
                        Variants: element.node.variants.nodes.map(v => ({
                            VariantId: v.id || 0,
                            Price: v?.price?.amount || 0,
                            Side: v.metafields.filter(m => m != undefined && m.key == "side")[0]?.value ?? "",
                            Material: v.metafields.filter(m => m != undefined && m.key == "material")[0]?.value ?? ""
                        })),
                        Image: element.node.metafields.filter(m => m != undefined && m.key == "vanityimage")[0]?.reference?.image?.src ?? "",
                        DKDImage: element.node.metafields.filter(m => m != undefined && m.key == "vanitydkdimage")[0]?.reference?.image?.src ?? "",
                        MinWidth: element.node.metafields.filter(m => m != undefined && m.key == "min_width")[0]?.value ?? 0,
                        MaxWidth: element.node.metafields.filter(m => m != undefined && m.key == "max_width")[0]?.value ?? 0
                    };
                    shopifyProducts.push(currentProduct);
                });
                shopifyData.data?.products?.edges?.forEach((element) => {
                    const currentProduct =
                    {
                        ProductId: element.node.id,
                        Name: element.node.title,
                        Description: element.node.metafields.filter(m => m != undefined && m.key == "vanity_product_description")[0]?.value ?? element.node.description,
                        ProductType: element.node.productType,
                        Model: element.node.metafields.filter(m => m != undefined && m.key == "vanitymodel")[0]?.value ?? "",
                        NumDoors: element.node.metafields.filter(m => m != undefined && m.key == "numdoors")[0]?.value ?? 0,
                        NumDrawers: element.node.metafields.filter(m => m != undefined && m.key == "numdrawers")[0]?.value ?? 0,
                        Variants: element.node.variants.nodes.map(v => ({
                            VariantId: v.id || 0,
                            Price: v?.price?.amount || 0,
                            Side: v.metafields.filter(m => m != undefined && m.key == "side")[0]?.value ?? "",
                            Material: v.metafields.filter(m => m != undefined && m.key == "material")[0]?.value ?? ""
                        })),
                        Image: element.node.metafields.filter(m => m != undefined && m.key == "vanityimage")[0]?.reference?.image?.src ?? "",
                        DKDImage: element.node.metafields.filter(m => m != undefined && m.key == "vanitydkdimage")[0]?.reference?.image?.src ?? "",
                        MinWidth: element.node.metafields.filter(m => m != undefined && m.key == "min_width")[0]?.value ?? 0,
                        MaxWidth: element.node.metafields.filter(m => m != undefined && m.key == "max_width")[0]?.value ?? 0
                    };
                    shopifyProducts.push(currentProduct);
                });
            }
            Object.entries(groupVanityConfigValues).forEach(([key, value]) => {
                if (value.length > 0) {
                    var cabinetConfigurations = [];
                    var maxDisplay = Math.max(...value.map(cc => cc.display));
                    var counterTopWidth = (value[0] || [])?.countertopwidth ?? 0;
                    var numOfSinks = (value[0] || [])?.NumSinks ?? 1;
                    var price = 0;
                    var numWallCab = 0;
                    var numWallCabTall = 0;
                    var dhNumber = 0;

                    const cabinetSides = this.getCabinetSideSkins(value,
                        VanityConfig.storeCustomerSelectedObject.WallLocationAbbr,
                        VanityConfig.storeCustomerSelectedObject.BoxMaterial,
                        VanityConfig.storeCustomerSelectedObject.CollectionColorFinish);

                    cabinetSides.forEach((vco) => {
                        const currentOption =
                        {
                            Model: vco.model,
                            NumDoors: vco.NumDoors,
                            NumDrawers: vco.NumDrawers,
                            Image: vco.img,
                            Istall: vco.istall,
                            HasFaucet: vco.HasFaucet,
                            Display: vco.display,
                            LeftSide: vco.left,
                            RightSide: vco.right,
                        };
                        cabinetConfigurations.push(currentOption);

                        var istall = currentOption.Istall;
                        var model = currentOption.Model;
                        var display = currentOption.Display;
                        var product = shopifyProducts.filter(sp => sp.Model == model)[0];
                        var fs30Product = shopifyProducts.filter(sp => sp.Model == "FS30")[0];
                        var fs84Product = shopifyProducts.filter(sp => sp.Model == "FS84")[0];
                        var mtk8Product = shopifyProducts.filter(sp => sp.Model == "MTK8")[0];
                        var dh45Product = shopifyProducts.filter(sp => sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel)[0];
                        var hdweProduct = shopifyProducts.filter(sp => sp.Model == "HDWE Template")[0];
                        var counterTopProduct = shopifyProducts.filter(sp => counterTopWidth > sp.MinWidth && counterTopWidth <= sp.MaxWidth)[0];
                        var endsplashProduct = [];
                        var endsplashProductPrice = 0;
                        var endsplashProductNumber = 1;
                        if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr != "N") {
                            endsplashProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("endsplash"))[0]
                            endsplashProductPrice = parseFloat(endsplashProduct.Variants[0]?.Price || 0);
                        }
                        var polishcutProduct = [];
                        var polishcutProductPrice = 0;
                        var polishcutProductNumber = 1;
                        if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr != "B") {
                            polishcutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("polishcut"))[0]
                            polishcutProductPrice = parseFloat(polishcutProduct.Variants[0]?.Price || 0);
                        }
                        if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr == "B") {
                            endsplashProductPrice = parseFloat(endsplashProduct.Variants[0]?.Price ?? 0) * 2;
                            endsplashProductNumber = 2;
                        }
                        if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr == "N") {
                            polishcutProductPrice = parseFloat(polishcutProduct.Variants[0]?.Price ?? 0) * 2;
                            polishcutProductNumber = 2;
                        }
                        var sinkColorProduct = null;
                        if (VanityConfig.storeCustomerSelectedObject.SinkColorProductId > 0) {
                            sinkColorProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkColorProductId) >= 0)[0];
                        }
                        var sinkShapeProduct = null;
                        if (VanityConfig.storeCustomerSelectedObject.SinkShapeProductId > 0) {
                            sinkShapeProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkShapeProductId) >= 0)[0];
                        }
                        var sinkCutProduct = {};
                        if (VanityConfig.storeCustomerSelectedObject?.CountertopMaterial?.toLowerCase() == "quartz") {
                            if (VanityConfig.storeCustomerSelectedObject?.SinkShape?.toLowerCase() == "oval") {
                                sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("pc-ovalcut"))[0]
                            } else {
                                sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("pc-rectcut"))[0]
                            }
                        } else {
                            if (VanityConfig.storeCustomerSelectedObject?.SinkShape?.toLowerCase() == "oval") {
                                sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("cl-ovalcut"))[0]
                            } else {
                                sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("cl-rectcut"))[0]
                            }
                        }

                        var desiredFaucetSpreadProduct = null;
                        if (VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId > 0) {
                            desiredFaucetSpreadProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId) >= 0)[0];
                        }

                        var productPrice = 0;
                        if (product != undefined) {
                            const selectedMaterial = VanityConfig.storeCustomerSelectedObject.BoxMaterial.toUpperCase();
                            const leftSide = currentOption.LeftSide || false;
                            const rightSide = currentOption.RightSide || false;
                            const bothSides = leftSide && rightSide;
                            const noneSide = !leftSide && !rightSide;

                            if (selectedMaterial == "PLY") {
                                let plyVariant = product.Variants.filter(v => v.Material.toUpperCase() == "PLYWOOD");
                                if (!plyVariant || _.isEmpty(plyVariant)) {
                                    plyVariant = product.Variants;//dkd30
                                }
                                productPrice = parseFloat(plyVariant[0]?.Price || 0);
                            } else {
                                var ewVariant = product.Variants.filter(v => v.Material.toUpperCase() == selectedMaterial);
                                if (bothSides) {
                                    ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "BOTH");
                                } else if (leftSide) {
                                    ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "LEFT");
                                } else if (rightSide) {
                                    ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "RIGHT");
                                } else if (noneSide) {
                                    ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "NO");
                                }
                                if (!ewVariant || _.isEmpty(ewVariant)) {
                                    ewVariant = product.Variants;//dkd30
                                }
                                productPrice = parseFloat(ewVariant[0]?.Price || 0);
                            }
                        }

                        price += parseFloat(productPrice);
                        dhNumber += parseFloat(vco?.NumDoors ?? 0) + parseFloat(vco?.NumDrawers ?? 0);
                        switch (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr) {
                            case "N":
                                break;
                            case "B":
                                if (display == 1 && istall == 1) {
                                    numWallCabTall++;
                                }
                                else if (display == 1) {
                                    numWallCab++;
                                }

                                if (display == maxDisplay && istall == 1) {
                                    numWallCabTall++;
                                }
                                else if (display == maxDisplay) {
                                    numWallCab++;
                                }
                                break;
                            case "L":
                                if (display == 1 && istall == 1) {
                                    numWallCabTall++;
                                }
                                else if (display == 1) {
                                    numWallCab++;
                                }
                                break;
                            case "R":
                                if (display == maxDisplay && istall == 1) {
                                    numWallCabTall++;
                                }
                                else if (display == maxDisplay) {
                                    numWallCab++;
                                }
                                break;
                            default: break;
                        }
                        if (display == maxDisplay) {
                            if (numWallCab > 0) {
                                price = (parseFloat(fs30Product.Variants[0]?.Price ?? 0) * numWallCab) + price;
                            }
                            if (numWallCabTall > 0) {
                                price = (parseFloat(fs84Product.Variants[0]?.Price ?? 0) * numWallCabTall) + price;
                            }
                            if (mtk8Product?.ProductId.length > 0) {
                                price = parseFloat(mtk8Product.Variants[0]?.Price ?? 0) + price;
                            }
                            if (dhNumber > 0) {
                                price = (parseFloat(dh45Product.Variants[0]?.Price ?? 0) * dhNumber) + price;
                                price = parseFloat((hdweProduct?.Variants[0]?.Price ?? 0)) + price;
                            }
                            if (VanityConfig.storeCustomerSelectedObject.SinkColorProductId > 0
                                && VanityConfig.storeCustomerSelectedObject.SinkShapeProductId > 0
                                && VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId > 0) {
                                price = price + parseFloat(counterTopProduct.Variants[0]?.Price ?? 0)
                                    + endsplashProductPrice + polishcutProductPrice
                                    + (parseFloat(desiredFaucetSpreadProduct.Variants[0]?.Price ?? 0) * numOfSinks)
                                    + (parseFloat(sinkShapeProduct.Variants[0]?.Price ?? 0) * numOfSinks)
                                    + (parseFloat(sinkCutProduct?.Variants[0]?.Price ?? 0) * numOfSinks)
                                    + (parseFloat(sinkColorProduct.Variants[0]?.Price ?? 0) * numOfSinks);

                            }
                        }
                    });

                    const currentConfig =
                    {
                        ConfigId: key,
                        LeftFiller: (value[0] || [])?.LeftFiller ?? 0,
                        RightFiller: (value[0] || [])?.RightFiller ?? 0,
                        LeftOverhang: (value[0] || [])?.LeftOverhang ?? 0,
                        RightOverhang: (value[0] || [])?.RightOverhang ?? 0,
                        NumOfSinks: (value[0] || [])?.NumSinks ?? 1,
                        CounterTopWidth: (value[0] || [])?.countertopwidth ?? 0,
                        NumTalls: (value[0] || [])?.numtalls ?? 0,
                        NumDrawerBases: (value[0] || [])?.numdrawerbases ?? 0,
                        NumDesks: (value[0] || [])?.numdesks ?? 0,
                        Wall: (value[0] || [])?.wall ?? "",
                        Width: (value[0] || [])?.width ?? 0,
                        CabinetSpace: (value[0] || [])?.cabinetspace ?? 0,
                        CounterTopSpace: (value[0] || [])?.countertopspace ?? 0,
                        SinkOffset1: (value[0] || [])?.SinkOffset1 ?? 0,
                        SinkOffset2: (value[0] || [])?.SinkOffset2 ?? 0,
                        DisplayOrder: (value[0] || [])?.displayorder ?? 0,
                        SinkRank: (value[0] || [])?.SinkRank ?? 0,
                        NumDeskRank: (value[0] || [])?.numdeskrank ?? 0,
                        NumDrawerRank: (value[0] || [])?.numDrawerRank ?? 0,
                        NumTallsRank: (value[0] || [])?.numtallsrank ?? 0,
                        TotalRank: (value[0] || [])?.totalRank ?? 0,
                        MaxDisplay: Math.max(...cabinetConfigurations.map(cc => cc.Display)),
                        Options: cabinetConfigurations,
                        Price: price,
                        ShopifyProducts: shopifyProducts,
                    };
                    vanityConfigValueOptions.push(currentConfig);
                }
            });
        }
        return vanityConfigValueOptions;
    },
    cabinetConfigurations: async function () {
        VanityConfig.showWaiting();
        var vanityConfigValueOptions = [];
        var shopifyFilterBody = [];

        vanityConfigValueOptions = VanityConfig.configurationOptions;
        var currentSelectedSorting = $(".configuration-options-sorting option:selected").first().val();
        switch (currentSelectedSorting) {
            case "displayorder-descending":
                vanityConfigValueOptions = vanityConfigValueOptions.toSorted((a, b) => {
                    if (b.DisplayOrder !== a.DisplayOrder) {
                        return b.DisplayOrder - a.DisplayOrder;
                    }
                    return String(a.configid).localeCompare(String(b.configid));
                });
                break;
            case "price-ascending":
                vanityConfigValueOptions = vanityConfigValueOptions.toSorted((a, b) => (a.Price - b.Price) || (b.DisplayOrder - a.DisplayOrder));
                break;
            case "price-descending":
                vanityConfigValueOptions = vanityConfigValueOptions.toSorted((a, b) => (b.Price - a.Price) || (b.DisplayOrder - a.DisplayOrder));
                break;
            default:
                break;
        }
        //#region make the filters
        if (VanityConfig.storeCustomerSelectedObject.Filters != undefined
            && VanityConfig.storeCustomerSelectedObject.Filters.length > 0) {
            var filterList = Object.groupBy(VanityConfig.storeCustomerSelectedObject.Filters, ({ Type }) => Type);
            for (const [key, value] of Object.entries(filterList).toSorted()) {
                switch (key) {
                    case "numofsinks":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => v.Value == vc.NumOfSinks));
                        break;
                    case "numtalls":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => v.Value == vc.NumTalls));
                        break;
                    case "numdrawerbases":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => v.Value == vc.NumDrawerBases));
                        break;
                    case "numdesks":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => v.Value == vc.NumDesks));
                        break;
                    case "cabinetwidth":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => vc.Options.find((vco) => vco.CabinetWidth == v.Value)));
                        break;
                    case "countertopwidth":
                        vanityConfigValueOptions = vanityConfigValueOptions.filter(vc => value.find((v) => v.Value == vc.CounterTopWidth));
                        break;
                }
            }
        }
        //#endregion
        var totalRecord = vanityConfigValueOptions?.length ?? 0;
        var totalPages = Math.ceil(parseFloat(totalRecord / VanityConfig.pageSize));
        if (totalPages == 0) {
            totalPages = 1;
        }
        await this.leftFilterMenu(vanityConfigValueOptions);
        var paginatedValueOptions = vanityConfigValueOptions.slice((VanityConfig.pageNum - 1) * VanityConfig.pageSize, VanityConfig.pageSize * VanityConfig.pageNum);
        var vanityWithoutTops = VanityConfig.enableCountertopWithoutTops && VanityConfig.storeCustomerSelectedObject.CountertopWithoutTops;
        if (vanityConfigValueOptions.length > 0 && paginatedValueOptions.length > 0) {
            var getShopifyData = paginatedValueOptions[0].ShopifyProducts;
            if (getShopifyData != undefined && getShopifyData.length > 0) {
                shopifyFilterBody.push(getShopifyData.filter(sp =>
                    (sp.Model != undefined && sp.Model != "" && sp.Model == "FS30") ||
                    (sp.Model != undefined && sp.Model != "" && sp.Model == "FS84") ||
                    (sp.Model != undefined && sp.Model != "" && sp.Model == "MTK8") ||
                    (sp.Model != undefined && sp.Model != "" && sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel) ||
                    (sp.Model != undefined && sp.Model != "" && sp.Model == "HDWE Template") ||
                    (sp.Name != undefined && sp.Name != "" && sp.Name.toLowerCase().includes("endsplash")) ||
                    (sp.Name != undefined && sp.Name != "" && sp.Name.toLowerCase().includes("ovalcut")) ||
                    (sp.Name != undefined && sp.Name != "" && sp.Name.toLowerCase().includes("rectcut")) ||
                    (sp.Name != undefined && sp.Name != "" && sp.Name.startsWith(VanityConfig.storeCustomerSelectedObject.CountertopFamilyCode)) ||
                    (vanityWithoutTops
                        ? false
                        : ((sp.Name != undefined && sp.Name != "" && sp.Name.toLowerCase().includes("polishcut")) ||
                            (sp.ProductId != undefined && sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkColorProductId) >= 0) ||
                            (sp.ProductId != undefined && sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkShapeProductId) >= 0) ||
                            (sp.ProductId != undefined && sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId) >= 0))
                    )
                ));
            }
            paginatedValueOptions.forEach((element) => {
                var getOptions = element.Options;
                if (getOptions != undefined) {
                    getOptions.forEach((option) => {
                        shopifyFilterBody.push(element.ShopifyProducts.filter(sp => sp.Model != undefined && sp.Model != "" && sp.Model == option.Model));
                    });
                }
            });

            var shopifyProducts = [];
            var postData = {};
            if (VanityConfig.siteName && VanityConfig.siteName.length > 0) {
                postData.siteName = VanityConfig.siteName;
            }
            var distinctShopifyFilterBody = [...new Set(shopifyFilterBody.flat().map(JSON.stringify))].map(JSON.parse);
            postData.products = JSON.stringify(distinctShopifyFilterBody.map((item) => {
                return { ProductId: item.ProductId };
            }));
            if (VanityConfig.enableB2BPrice && VanityConfig.enableB2BPrice == true) {
                postData.isLoggedIn = VanityConfig.isLoggedIn;
                postData.companyLocationId = VanityConfig.companyLocationId;
            }
            var shopifyData = await this.postDataApi(VanityConfig.readVanityProductsSource, postData)
                .catch((error) => {
                    console.log(error);
                });

            if (shopifyData != undefined && shopifyData.Data.success && shopifyData.Data.products != undefined) {
                shopifyData.Data.products.forEach((element) => {

                    const currentProduct =
                    {
                        ProductId: element.node.id,
                        Name: element.node.title,
                        ProductType: element.node.productType,
                        Description: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.vanity_product_description")[0]?.node?.value ?? element.node.description,
                        Model: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.vanitymodel")[0]?.node?.value ?? "",
                        NumDoors: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.numdoors")[0]?.node?.value ?? 0,
                        NumDrawers: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.numdrawers")[0]?.node?.value ?? 0,
                        Variants: element.node.variants.edges.map(({ node: v }) => {
                            let price = v?.price || 0;
                            if (VanityConfig.enableB2BPrice && VanityConfig.enableB2BPrice == true) {
                                price = v?.contextualPricing?.price?.amount || 0;
                            }

                            return {
                                VariantId: v.id || 0,
                                Price: price,
                                Side: v.metafields.edges.filter(({ node: m }) => m != undefined && m.key == "custom.side")[0]?.node?.value ?? "",
                                Material: v.metafields.edges.filter(({ node: m }) => m != undefined && m.key == "custom.material")[0]?.node?.value ?? "",
                                Description: v.metafields.edges.filter(({ node: m }) => m != undefined && m.key == "custom.description")[0]?.node?.value ?? ""
                            };
                        }),
                        Image: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.vanityimage")[0]?.node?.reference?.image?.src ?? "",
                        DKDImage: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.vanitydkdimage")[0]?.node?.reference?.image?.src ?? "",
                        DH45100Image: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.vanity_dh45_100_image")[0]?.node?.reference?.image?.src ?? "",
                        MinWidth: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.min_width")[0]?.node?.value ?? 0,
                        MaxWidth: element.node.metafields.edges.filter(({ node }) => node != undefined && node.key == "custom.max_width")[0]?.node?.value ?? 0
                    };
                    shopifyProducts.push(currentProduct);
                });
            }
            var cabinetHTML = ``;
            paginatedValueOptions.forEach((element, index) => {
                const selectedMaterial = VanityConfig.storeCustomerSelectedObject.BoxMaterial.toUpperCase();

                var leftFiller = element.LeftFiller;
                var rightFiller = element.RightFiller;
                var leftOverhang = element.LeftOverhang;
                var rightOverhang = element.RightOverhang;
                var maxDisplay = element.MaxDisplay;
                var numOfSinks = element.NumOfSinks;
                var sinkOffset1 = element.SinkOffset1;
                var sinkOffset2 = element.SinkOffset2;
                // var counterWidthDescription = element.CounterWidthDescription;
                var cabinetImage = "";
                var cabinetPrice = "";
                var cabinetDescription = `<dt style=" font-weight: 500; color: #8a8888; text-transform: uppercase;">What's Included</dt>`;
                var fullAssembledCabinetryDescription = `<dt style="margin-bottom: 0px;padding-bottom: 3px;font-size: 1.6rem;">Assembled${selectedMaterial == "EW" ? "" : " Plywood"} Cabinetry</dt>`;
                var countertopSinkDescription = `<dt style="margin-bottom: 0px;padding-bottom: 3px;padding-top: 10px;font-size: 1.6rem;">Countertop & Sink</dt>`;
                var hardwareDescription = `<dt style="margin-bottom: 0px;padding-bottom: 3px;padding-top: 10px;font-size: 1.6rem;">Hardware</dt>`;
                var price = 0;
                var numWallCab = 0;
                var numWallCabTall = 0;
                var dhNumber = 0;
                var ltfiller30 = 0;
                var ltfiller84 = 0;
                var rtfiller30 = 0;
                var rtfiller84 = 0;
                var selectedProducts = [];
                var selectedProductCounterTop = "";
                var hastall = (element.Options.filter(sp => sp.Istall == 1) || []).length > 0;

                var vanityWidth = parseInt(VanityConfig.storeCustomerSelectedObject.VanityWidth) + parseFloat(VanityConfig.storeCustomerSelectedObject.VanityFillerStripFloat);

                var imagesize = "";
                if (vanityWidth >= 25 && vanityWidth < 47) {
                    imagesize = "-47";
                } else if (vanityWidth >= 47 && vanityWidth < 65) {
                    imagesize = "-65";
                } else if (vanityWidth >= 83 && vanityWidth < 98) {
                    imagesize = "-98";
                } else if (vanityWidth >= 98 && vanityWidth < 500) {
                    imagesize = "-500";
                }

                var dh45Product = shopifyProducts.filter(sp => sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel)[0];
                element.Options.forEach((option, index) => {
                    var istall = option.Istall;
                    var model = option.Model;
                    var display = option.Display;
                    var product = shopifyProducts.filter(sp => sp.Model == model)[0];
                    var fs30Product = shopifyProducts.filter(sp => sp.Model == "FS30")[0];
                    var fs84Product = shopifyProducts.filter(sp => sp.Model == "FS84")[0];
                    var mtk8Product = shopifyProducts.filter(sp => sp.Model == "MTK8")[0];
                    var hdweProduct = shopifyProducts.filter(sp => sp.Model == "HDWE Template")[0];
                    var counterTopProduct = shopifyProducts.filter(sp => element.CounterTopWidth > sp.MinWidth && element.CounterTopWidth <= sp.MaxWidth)[0];
                    var endsplashProduct = [];
                    var endsplashProductPrice = 0;
                    var endsplashProductNumber = 1;
                    if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr != "N") {
                        endsplashProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("endsplash"))[0]
                        endsplashProductPrice = parseFloat(endsplashProduct?.Variants[0]?.Price ?? 0);
                    }
                    var polishcutProduct = [];
                    var polishcutProductPrice = 0;
                    var polishcutProductNumber = 1;
                    if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr != "B") {
                        polishcutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("polishcut"))[0]
                        polishcutProductPrice = parseFloat(polishcutProduct?.Variants[0]?.Price ?? 0);
                    }
                    if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr == "B") {
                        endsplashProductPrice = parseFloat(endsplashProduct?.Variants[0]?.Price ?? 0) * 2;
                        endsplashProductNumber = 2;
                    }
                    if (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr == "N") {
                        polishcutProductPrice = parseFloat(polishcutProduct?.Variants[0]?.Price ?? 0) * 2;
                        polishcutProductNumber = 2;
                    }
                    var sinkColorProduct = null;
                    if (VanityConfig.storeCustomerSelectedObject.SinkColorProductId > 0) {
                        sinkColorProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkColorProductId) >= 0)[0];
                    }
                    var sinkShapeProduct = null;
                    if (VanityConfig.storeCustomerSelectedObject.SinkShapeProductId > 0) {
                        sinkShapeProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.SinkShapeProductId) >= 0)[0];
                    }
                    var sinkCutProduct = {};
                    if (VanityConfig.storeCustomerSelectedObject?.CountertopMaterial?.toLowerCase() == "quartz") {
                        if (VanityConfig.storeCustomerSelectedObject?.SinkShape?.toLowerCase() == "oval") {
                            sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("pc-ovalcut"))[0]
                        } else {
                            sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("pc-rectcut"))[0]
                        }
                    } else {
                        if (VanityConfig.storeCustomerSelectedObject?.SinkShape?.toLowerCase() == "oval") {
                            sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("cl-ovalcut"))[0]
                        } else {
                            sinkCutProduct = shopifyProducts.filter(sp => sp.Name != undefined && sp.Name.toLowerCase().includes("cl-rectcut"))[0]
                        }
                    }
                    var desiredFaucetSpreadProduct = null;
                    if (VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId > 0) {
                        desiredFaucetSpreadProduct = shopifyProducts.filter(sp => sp.ProductId.indexOf(VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId) >= 0)[0];
                    }

                    const leftSide = option.LeftSide || false;
                    const rightSide = option.RightSide || false;
                    const bothSides = leftSide && rightSide;
                    const noneSide = !leftSide && !rightSide;
                    var variant = null;
                    var productPrice = 0;

                    var skinned = "";

                    if (product != undefined) {
                        if (selectedMaterial == "PLY") {
                            let plyVariant = product.Variants.filter(v => v.Material.toUpperCase() == "PLYWOOD");

                            if (!plyVariant || _.isEmpty(plyVariant)) {
                                plyVariant = product.Variants;//dkd30
                            }
                            productPrice = parseFloat(plyVariant[0]?.Price || 0);

                            variant = plyVariant[0];
                        } else {
                            var ewVariant = product.Variants.filter(v => v.Material.toUpperCase() == selectedMaterial);
                            if (bothSides) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "BOTH");
                                skinned = "- Skinned Both"
                            } else if (leftSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "LEFT");
                                skinned = "- Skinned Left"
                            } else if (rightSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "RIGHT");
                                skinned = "- Skinned Right"
                            } else if (noneSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "NO");
                            }
                            if (!ewVariant || _.isEmpty(ewVariant)) {
                                ewVariant = product.Variants;//dkd30
                            }

                            productPrice = parseFloat(ewVariant[0]?.Price || 0);

                            variant = ewVariant[0];
                        }
                    }

                    price += parseFloat(productPrice);

                    if (product != undefined) {
                        let variantDescription = null;
                        if (selectedMaterial == "EW") {
                            const tempDescription = variant?.Description || "";
                            if (!_.isEmpty(tempDescription)) {
                                if (bothSides) {
                                    variantDescription = `${tempDescription} - Both`;
                                } else if (leftSide) {
                                    variantDescription = `${tempDescription} - Left`;
                                } else if (rightSide) {
                                    variantDescription = `${tempDescription} - Right`;
                                }
                            }
                        }
                        selectedProducts.push({
                            "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`,
                            "configid": `${element.ConfigId}`,
                            "type": "product",
                            "width": VanityConfig.toFraction(element.Width),
                            "description": `${product?.Description} ${skinned}`,
                            "material": VanityConfig.storeCustomerSelectedObject.BoxMaterial,
                            "leftSide": leftSide,
                            "rightSide": rightSide,
                            "bothSides": bothSides,
                            "noneSide": noneSide,
                            "oedescription": `Cabinet #${display}`,
                            "productid": product.ProductId,
                            "variantid": variant?.VariantId || "",
                            ...(variantDescription && { "variantdescription": variantDescription || "", }),
                            "number": 1,
                            display,
                            istall,
                            model,
                            product,
                        });
                    }
                    dhNumber += parseFloat(product?.NumDoors ?? 0) + parseFloat(product?.NumDrawers ?? 0);

                    var dh45ProductImage = "";
                    if (product?.DH45100Image) {
                        dh45ProductImage = product.DH45100Image;
                    }
                    if (istall == 1) {
                        cabinetImage += `<div style="display: flex; flex-direction: column;align-items: center;position: relative;">
                                            <img 
                                            border="0" 
                                            class="vanity-tall-cabinet${imagesize}" 
                                            src="${product?.Image ?? ""}"
                                            loading="lazy"
                                            style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />
                                            ${dh45ProductImage.length > 0 ? `<img src="${dh45ProductImage}" alt="${dh45Product?.Name ?? ""}" 
                                            style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;  " />` : ""}
                                            <!-- toekick image -->
                                            <img
                                                src="${VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image}"
                                                loading="lazy"
                                                alt="toekick"
                                                class="vanity-toekick${imagesize}"
                                                style="position: absolute;
                                                bottom: 0;
                                                left: 0; 
                                                width: 101%;
                                                z-index: 5;
                                                object-fit: fill;
                                                --vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"                                                    
                                            />
                                         </div>`;
                    } else {
                        if (option.HasFaucet == 1 && product != undefined) {
                            cabinetImage += `<div style="display: flex; flex-direction: column;align-items: center;position: relative;">
                            ${!vanityWithoutTops ? `<!-- faucet image -->
                                                <img
                                                    border="0"
                                                    class="vanity-faucet${imagesize}"
                                                    src="${desiredFaucetSpreadProduct?.Image ?? ""}"
                                                    loading="lazy"                                                    
                                                />`: ""}
                                                <div style="position: relative">                                                
                                                    <img
                                                        border="0"
                                                        class="vanity-base-cabinet${imagesize}"
                                                        src="${product?.Image ?? ""}"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};" 
                                                    />
                                                    ${dh45ProductImage.length > 0 ? `<img src="${dh45ProductImage}" alt="${dh45Product?.Name ?? ""}" 
                                                    style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;  " />` : ""}
                                                </div>
                                                <!-- toekick image -->
                                                <img
                                                    src="${VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image}"
                                                    loading="lazy"
                                                    alt="toekick"
                                                    class="vanity-toekick${imagesize}"
                                                    style="position: absolute;
                                                    bottom: 0;
                                                    left: 0;
                                                    width: 101%;
                                                    z-index: 5;
                                                    object-fit: fill;
                                                    --vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"                                                    
                                                />
                                            </div>`;
                        } else {
                            if (model.toLowerCase() == "dkd30" && product != undefined) {
                                cabinetImage += `
                                <div style="display: flex; flex-direction: column;align-items: center;position: relative;">
                                    <img  border="0"
                                        class="vanity-dkd30${imagesize}"
                                        src="${product?.Image ?? ""}"
                                        loading="lazy"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />
                                        ${dh45ProductImage.length > 0 ? `<img src="${dh45ProductImage}" alt="${dh45Product?.Name ?? ""}" 
                                        class="vanity-dkd30${imagesize}"
                                        style=" position: absolute; pointer-events: none;  " />` : ""}
                                </div>`;
                            } else {
                                cabinetImage += `<div style="display: flex; flex-direction: column;align-items: center;position: relative;">
                                                    <img 
                                                        border="0" 
                                                        class="vanity-base-cabinet${imagesize}" 
                                                        src="${product?.Image ?? ""}"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};" />
                                                    ${dh45ProductImage.length > 0 ? `<img src="${dh45ProductImage}" alt="${dh45Product?.Name ?? ""}" 
                                                    style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;  " />` : ""}
                                                    <!-- toekick image -->
                                                    <img
                                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleMTK8Image}"
                                                        loading="lazy"
                                                        alt="toekick"
                                                        class="vanity-toekick${imagesize}"
                                                        style="position: absolute;
                                                        bottom: 0;
                                                        left: 0;
                                                        width: 101%;
                                                        z-index: 5;
                                                        object-fit: fill;
                                                        --vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"                                                    
                                                    />
                                                </div>`;

                            }

                        }
                    }

                    fullAssembledCabinetryDescription += `<dd>1 x ${product?.Description} ${skinned}</dd>`;

                    switch (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr) {
                        case "N":
                            if (display == 1 && istall == 0) {
                                cabinetImage = `<div
                                                    style="
                                                        ${!vanityWithoutTops ? `display: flex;` : "display: none;"}                                                        
                                                        flex-direction: column;
                                                        align-items: center;
                                                        position: relative;
                                                    "
                                                    >
                                                    <img
                                                        border="0"
                                                        class="vanity-base-cabinet${imagesize}"
                                                        src="//idealcabinetry.com/cdn/shop/files/overhang-fillerstrip-20250805.png?v=17513199877620613336"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color:
                                                    ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};border: none;
                                                    background: transparent;
                                                    box-shadow: none;"
                                                    />
                                                    </div>
                                                    ${cabinetImage}`;
                            }
                            if (display == maxDisplay && istall == 0) {
                                cabinetImage += `<div
                                                    style="
                                                        ${!vanityWithoutTops ? `display: flex;` : "display: none;"}
                                                        flex-direction: column;
                                                        align-items: center;
                                                        position: relative;
                                                    "
                                                    >
                                                    <img
                                                        border="0"
                                                        class="vanity-base-cabinet${imagesize}"
                                                        src="//idealcabinetry.com/cdn/shop/files/overhang-fillerstrip-20250805.png?v=17513199877620613336"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color:
                                                    ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};border: none;
                                                    background: transparent;
                                                    box-shadow: none;"
                                                    />
                                                    </div>`;
                            }
                            break;
                        case "B":
                            if (display == 1 && istall == 1) {
                                numWallCabTall++;
                                if (leftFiller != "0.00") {
                                    cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}" src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293" style="box-shadow: none;" />
                                    <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};" 
                                    src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image}" />${cabinetImage}`;
                                    ltfiller84++;
                                }
                            }
                            else if (display == 1) {
                                numWallCab++;
                                if (leftFiller != "0.00") {
                                    if (model.toLowerCase() == "dkd30" && product != undefined) {
                                        cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293" />
                                        <img border="0" class="vanity-base-cabinet${imagesize} vanity-dkd-fs${imagesize}" 
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage}" />${cabinetImage}`;
                                    }
                                    else {
                                        cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293" />
                                        <img 
                                        border="0" 
                                        class="vanity-base-cabinet${imagesize}" 
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image}" />${cabinetImage}`;
                                    }
                                    ltfiller30++;
                                }
                            }

                            if (display == maxDisplay && istall == 1) {
                                numWallCabTall++;
                                if (rightFiller != "0.00") {
                                    cabinetImage += `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image}"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                    <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />`;
                                    rtfiller84++;
                                }
                            }
                            else if (display == maxDisplay) {
                                numWallCab++;
                                if (rightFiller != "0.00") {
                                    if (model.toLowerCase() == "dkd30" && product != undefined) {
                                        cabinetImage += `<img border="0" class="vanity-base-cabinet${imagesize} vanity-dkd-fs${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                        <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />`;
                                    }
                                    else {
                                        cabinetImage += `<img border="0" class="vanity-base-cabinet${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                        <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />`;
                                    }
                                    rtfiller30++;
                                }
                            }
                            break;
                        case "L":
                            if (display == 1 && istall == 1) {
                                numWallCabTall++;
                                if (leftFiller != "0.00") {
                                    cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                    <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image}"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />${cabinetImage}`;
                                    ltfiller84++;
                                }
                            }
                            else if (display == 1) {
                                numWallCab++;
                                if (leftFiller != "0.00") {
                                    if (model.toLowerCase() == "dkd30" && product != undefined) {
                                        cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                        <img border="0" class="vanity-base-cabinet${imagesize} vanity-dkd-fs${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />${cabinetImage}`;
                                    }
                                    else {
                                        cabinetImage = `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />
                                        <img border="0" class="vanity-base-cabinet${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />${cabinetImage}`;
                                    }
                                    ltfiller30++;
                                }
                            }

                            if (display == maxDisplay && istall == 0) {
                                cabinetImage += `<div
                                                    style="
                                                        ${!vanityWithoutTops ? `display: flex;` : "display: none;"}
                                                        flex-direction: column;
                                                        align-items: center;
                                                        position: relative;
                                                    "
                                                    >
                                                    <img
                                                        border="0"
                                                        class="vanity-base-cabinet${imagesize}"
                                                        src="//idealcabinetry.com/cdn/shop/files/overhang-fillerstrip-20250805.png?v=17513199877620613336"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color:
                                                    ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};border: none;
                                                    background: transparent;
                                                    box-shadow: none;"
                                                    />
                                                    </div>`;
                            }
                            break;
                        case "R":
                            if (display == 1 && istall == 0) {
                                cabinetImage = `<div
                                                    style="
                                                        ${!vanityWithoutTops ? `display: flex;` : "display: none;"}
                                                        flex-direction: column;
                                                        align-items: center;
                                                        position: relative;
                                                    "
                                                    >
                                                    <img
                                                        border="0"
                                                        class="vanity-base-cabinet${imagesize}"
                                                        src="//idealcabinetry.com/cdn/shop/files/overhang-fillerstrip-20250805.png?v=17513199877620613336"
                                                        loading="lazy"
                                                        style="--vanity-toekick-color:
                                                    ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};border: none;
                                                    background: transparent;
                                                    box-shadow: none;"
                                                    />
                                                    </div>
                                                    ${cabinetImage}`;
                            }
                            if (display == maxDisplay && istall == 1) {
                                numWallCabTall++;
                                if (rightFiller != "0.00") {
                                    cabinetImage += `<img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS84Image}"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />
                                    <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                    src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                    style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />`;
                                    rtfiller84++;
                                }
                            }
                            else if (display == maxDisplay) {
                                numWallCab++;
                                if (rightFiller != "0.00") {
                                    if (model.toLowerCase() == "dkd30" && product != undefined) {
                                        cabinetImage += `<img border="0" class="vanity-base-cabinet${imagesize} vanity-dkd-fs${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30DKDImage}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />
                                        <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;"  />`;
                                    }
                                    else {
                                        cabinetImage += `<img border="0" class="vanity-base-cabinet${imagesize}" 
                                        src="${VanityConfig.storeCustomerSelectedObject.DoorStyleFS30Image}"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};"  />
                                        <img border="0" class="vanity-tall-cabinet${imagesize}" 
                                        src="//idealcabinetry.com/cdn/shop/files/walltrim-20250522.png?v=6725651414723628293"
                                        style="--vanity-toekick-color: ${VanityConfig.storeCustomerSelectedObject.ToeKickColor};box-shadow: none;" />`;
                                    }
                                    rtfiller30++;
                                }
                            }
                            break;
                        default: break;
                    }
                    if (display == maxDisplay) {
                        if (numWallCab > 0) {
                            price = (parseFloat(fs30Product?.Variants[0]?.Price ?? 0) * numWallCab) + price;

                        }
                        if (numWallCabTall > 0) {
                            price = (parseFloat(fs84Product?.Variants[0]?.Price ?? 0) * numWallCabTall) + price;

                        }
                        if (mtk8Product?.ProductId.length > 0) {
                            price = parseFloat(mtk8Product?.Variants[0]?.Price ?? 0) + price;

                        }
                        if (dhNumber > 0) {
                            price = (parseFloat(dh45Product?.Variants[0]?.Price ?? 0) * dhNumber) + price;
                            price = parseFloat((hdweProduct?.Variants[0]?.Price ?? 0)) + price;

                        }
                        price = price + endsplashProductPrice + parseFloat(counterTopProduct?.Variants[0]?.Price ?? 0);
                        if (VanityConfig.storeCustomerSelectedObject.SinkColorProductId > 0
                            && VanityConfig.storeCustomerSelectedObject.SinkShapeProductId > 0
                            && VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpreadProductId > 0) {
                            price = price
                                + polishcutProductPrice
                                + (parseFloat(desiredFaucetSpreadProduct?.Variants[0]?.Price ?? 0) * numOfSinks)
                                + (parseFloat(sinkShapeProduct?.Variants[0]?.Price ?? 0) * numOfSinks)
                                + (parseFloat(sinkCutProduct?.Variants[0]?.Price ?? 0) * numOfSinks)
                                + (parseFloat(sinkColorProduct?.Variants[0]?.Price ?? 0) * numOfSinks);

                        }

                        var discountedPrice = price;
                        var savedPrice = 0;
                        if (parseFloat(VanityConfig.CollectionBundleDiscount) > 0) {
                            discountedPrice = price * (100 - parseFloat(VanityConfig.CollectionBundleDiscount)) / 100.0;
                            savedPrice = price - discountedPrice;
                        }

                        if (VanityConfig.rounded) {
                            var modulo = discountedPrice % 10;
                            if (modulo > 0) {
                                discountedPrice = discountedPrice - modulo;
                                savedPrice = savedPrice + modulo;
                            }
                        }
                        cabinetPrice = `<div><strong>${Ideal.formatMoney(discountedPrice, VanityConfig.rounded ? Ideal.money_no_decimals_format : Ideal.money_format)}</strong></div>
                            <div>
                            <p>
                            ${savedPrice > 0 ? `<del>${Ideal.formatMoney(price, Ideal.money_format)}</del>
                            <span class="text_red" style="font-weight: 500">
                            Save ${Ideal.formatMoney(savedPrice, Ideal.money_format)} ${parseFloat(VanityConfig.CollectionBundleDiscount) > 0 ? `(${VanityConfig.CollectionBundleDiscount}%)` : ""} 
                            </span>`: ""}                            
                            </p>
                            </div>`;

                        var counterTopDescription = "";
                        var counterTopOEDescription = "";
                        var sinkColorDescription = "";
                        var sinkColorOEDescription = "";
                        var fs30ProductDescription = "";
                        var fs84ProductDescription = "";
                        var dh45ProductDescription = "";
                        var endsplashproductDescription = "";
                        var polishcutproductDescription = "";
                        var mtk8ProductDescription = "";

                        if (!vanityWithoutTops) {
                            if (VanityConfig.storeCustomerSelectedObject.Countertop) {
                                selectedProductCounterTop = `${VanityConfig.toFraction(element.CounterTopWidth)}" Wide Countertop`;
                                counterTopDescription = `${VanityConfig.storeCustomerSelectedObject.Countertop} ${VanityConfig.storeCustomerSelectedObject.CountertopMaterial} ${VanityConfig.storeCustomerSelectedObject.CountertopLabel} - ${VanityConfig.toFraction(element.CounterTopWidth)}"W x 22"D w/4" Backsplash`;
                                counterTopOEDescription = `${VanityConfig.toFraction(element.CounterTopWidth)}" x 22" ${VanityConfig.storeCustomerSelectedObject.Countertop} 4" Back`;
                                sinkColorDescription = `${numOfSinks} x ${VanityConfig.storeCustomerSelectedObject.SinkSize} ${VanityConfig.storeCustomerSelectedObject.SinkColor} ${VanityConfig.storeCustomerSelectedObject.SinkFinish} ${VanityConfig.storeCustomerSelectedObject.SinkShape} ${(numOfSinks > 1 ? " Sinks" : " Sink")} (Undermount, ${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread})`;
                                countertopSinkDescription += `
                                <dd>1 x ${counterTopDescription}<a              
                                rel="popover"
                                data-html="true"
                                data-content="<div class='producthint'><img width='230' height='260' style='height: 260px;object-fit: cover;' src='${VanityConfig.storeCustomerSelectedObject.CountertopImage}' /></div>"
                                data-placement="top"
                                data-toggle="popover"
                                data-trigger="hover"                 
                                onclick="return false;"
                                aria-label="help"   
                            > <img
                                class="img-responsive"
                                alt=""
                                src="//idealcabinetry.com/cdn/shop/files/info-icon.png?v=8116898556685794667"
                                rel=""
                                width="20"
                                height="20"
                                loading="lazy"
                                style="display:inline-block;"
                            ></a></dd>`;
                            }
                            if (window._.isNumber(leftOverhang) && leftOverhang > 0) {
                                countertopSinkDescription += `<dd>1 x ${VanityConfig.toFraction(leftOverhang)}" Left Overhang</dd>`;
                            }
                            if (window._.isNumber(rightOverhang) && rightOverhang > 0) {
                                countertopSinkDescription += `<dd>1 x ${VanityConfig.toFraction(rightOverhang)}" Right Overhang</dd>`;
                            }
                        } else {
                            counterTopDescription = counterTopProduct?.Description ?? "";
                            counterTopOEDescription = counterTopProduct?.Description ?? "";
                            countertopSinkDescription += `
                                <dd>1 x ${counterTopDescription}</dd>`;
                        }
                        const sinkColorDescriptionHTML = `<dd>${sinkColorDescription}<a              
                            rel="popover"
                            data-html="true"
                            data-content="<div class='producthint'><img width='230' height='260' style='height: 260px;object-fit: cover;' src='${VanityConfig.storeCustomerSelectedObject.SinkShapeImage}' /></div>"
                            data-placement="top"
                            data-toggle="popover"
                            data-trigger="hover"                 
                            onclick="return false;"
                            aria-label="help"   
                          > <img
                            class="img-responsive"
                            alt=""
                            src="//idealcabinetry.com/cdn/shop/files/info-icon.png?v=8116898556685794667"
                            rel=""
                            width="20"
                            height="20"
                            loading="lazy"
                            style="display:inline-block;"
                          ></a></dd>`;
                        if (counterTopProduct != undefined) {
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "countertopproduct", "width": VanityConfig.toFraction(element.Width), "description": counterTopDescription, "oedescription": counterTopOEDescription, "productid": counterTopProduct.ProductId, "number": 1 });
                        }
                        if (sinkColorProduct != undefined) {
                            sinkColorOEDescription = `${VanityConfig.storeCustomerSelectedObject.SinkShape} sink CP ${sinkOffset1} from Left`;
                            if (numOfSinks > 1) {
                                sinkColorOEDescription += ":" + `${VanityConfig.storeCustomerSelectedObject.SinkShape} sink CP ${sinkOffset2} from Left`;
                            }
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "sinkcolorproduct", "width": VanityConfig.toFraction(element.Width), "description": VanityConfig.storeCustomerSelectedObject.SinkColor, "oedescription": sinkColorOEDescription, "productid": sinkColorProduct.ProductId, "number": numOfSinks });
                        }
                        if (sinkShapeProduct != undefined) {
                            var sinkShapeOEDescription = `Center point ${sinkOffset1} from Left`;
                            if (numOfSinks > 1) {
                                sinkShapeOEDescription += ":" + `Center point ${sinkOffset2} from Left`;
                            }
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "sinkshapeproduct", "width": VanityConfig.toFraction(element.Width), "description": VanityConfig.storeCustomerSelectedObject.SinkShape, "oedescription": sinkShapeOEDescription, "productid": sinkShapeProduct.ProductId, "number": numOfSinks });
                        }
                        if (sinkCutProduct != undefined) {
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "sinkcutproduct", "width": VanityConfig.toFraction(element.Width), "description": sinkCutProduct?.Description, "oedescription": sinkCutProduct?.Description, "productid": sinkCutProduct.ProductId, "number": numOfSinks });
                        }
                        if (desiredFaucetSpreadProduct != undefined) {
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "desiredfaucetspreadproduct", "width": VanityConfig.toFraction(element.Width), "description": VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread, "oedescription": VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread, "productid": desiredFaucetSpreadProduct.ProductId, "number": numOfSinks });
                        }
                        if (ltfiller30 > 0) {
                            fs30ProductDescription = `${VanityConfig.toFraction(leftFiller)}" x 30" Trimable Filler Strip (Left Wall)`;
                            fullAssembledCabinetryDescription += `<dd>1 x ${fs30ProductDescription}</dd>`;
                            var fs30ProductOEDescription = `${leftFiller}" x 30" Trimable Strip for left wall`;
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "fs30product", "width": VanityConfig.toFraction(element.Width), "description": fs30ProductDescription, "oedescription": fs30ProductOEDescription, "productid": fs30Product.ProductId, "number": 1 });
                        }
                        if (ltfiller84 > 0) {
                            fs84ProductDescription = `${VanityConfig.toFraction(leftFiller)}" x 84" Trimable Filler Strip (Left Wall)`;
                            fullAssembledCabinetryDescription += `<dd>1 x ${fs84ProductDescription}</dd>`;
                            var fs84ProductOEDescription = `${leftFiller}" x 84" Trimable Strip for left wall`;
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "fs84product", "width": VanityConfig.toFraction(element.Width), "description": fs84ProductDescription, "oedescription": fs84ProductOEDescription, "productid": fs84Product.ProductId, "number": 1 });
                        }
                        if (rtfiller30 > 0) {
                            fs30ProductDescription = `${VanityConfig.toFraction(rightFiller)}" x 30" Trimable Filler Strip (Right Wall)`;
                            fullAssembledCabinetryDescription += `<dd>1 x ${fs30ProductDescription}</dd>`;
                            var fs30ProductOEDescription = `${rightFiller}" x 30" Trimable Strip for right wall`;
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "fs30product", "width": VanityConfig.toFraction(element.Width), "description": fs30ProductDescription, "oedescription": fs30ProductOEDescription, "productid": fs30Product.ProductId, "number": 1 });
                        }
                        if (rtfiller84 > 0) {
                            fs84ProductDescription = `${VanityConfig.toFraction(rightFiller)}" x 84" Trimable Filler Strip (Right Wall)</span>`;
                            fullAssembledCabinetryDescription += `<dd>1 x ${fs84ProductDescription}</dd>`;
                            var fs84ProductOEDescription = `${rightFiller}" x 84" Trimable Strip for right wall`;
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "fs84product", "width": VanityConfig.toFraction(element.Width), "description": fs84ProductDescription, "oedescription": fs84ProductOEDescription, "productid": fs84Product.ProductId, "number": 1 });
                        }
                        if (dhNumber > 0) {
                            dh45ProductDescription = `${dh45Product?.Description ?? ""}`;
                            hardwareDescription += `<dd>${dhNumber} x ${dh45Product?.Description ?? ""}<a              
                            rel="popover"
                            data-html="true"
                            data-content="<div class='producthint'><img  width='220' height='225' src='${dh45Product?.Image ?? ""}' /></div>"
                            data-placement="top"
                            data-toggle="popover"
                            data-trigger="hover"                 
                            onclick="return false;"
                            aria-label="help"   
                          > <img
                            class="img-responsive"
                            alt=""
                            src="//idealcabinetry.com/cdn/shop/files/info-icon.png?v=8116898556685794667"
                            rel=""
                            width="20"
                            height="20"
                            loading="lazy"
                            style="display:inline-block;"
                          ></a></dd>`;
                        }
                        if (dhNumber > 0) {
                            if (dh45Product != undefined) {
                                selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "dh45product", "width": VanityConfig.toFraction(element.Width), "description": dh45ProductDescription, "oedescription": dh45ProductDescription, "productid": dh45Product.ProductId, "number": dhNumber });
                            }
                            if (hdweProduct != undefined) {
                                selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "hdweproduct", "width": VanityConfig.toFraction(element.Width), "description": "", "oedescription": "", "productid": hdweProduct.ProductId, "number": 1 });
                            }
                        }
                        if (!vanityWithoutTops) {
                            switch (VanityConfig.storeCustomerSelectedObject.WallLocationAbbr) {
                                case "N":
                                    var polishcutproductDescription1 = "Left-Side Polished Edge (Countertop)";
                                    var polishcutproductOEDescription1 = "Left polished edge - eased edge profile";
                                    var polishcutproductDescription2 = `Right-Side Polished Edge (Countertop)`;
                                    var polishcutproductOEDescription2 = "Right polished edge - eased edge profile";
                                    if (polishcutProduct != undefined) {
                                        countertopSinkDescription += `<dd>1 x ${polishcutproductDescription1}</dd>
                                <dd>1 x ${polishcutproductDescription2}</dd>${sinkColorDescriptionHTML}`;
                                        // polishcutproductDescription = endsplashproductDescription + "<br/>" + polishcutproductDescription;//saved to metafield for cart display
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "polishcutproduct", "width": VanityConfig.toFraction(element.Width), "description": polishcutproductDescription1, "oedescription": polishcutproductOEDescription1, "productid": polishcutProduct.ProductId, "number": 1 });
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "polishcutproduct", "width": VanityConfig.toFraction(element.Width), "description": polishcutproductDescription2, "oedescription": polishcutproductOEDescription2, "productid": polishcutProduct.ProductId, "number": 1 });
                                    }
                                    break;
                                case "B":
                                    var endsplashproductDescription1 = `22" Side Splash (Left Wall)`;
                                    var endsplashproductOEDescription1 = `22" x 4" Sidesplash for left wall`;
                                    var endsplashproductDescription2 = `22" Side Splash (Right Wall)`;
                                    var endsplashproductOEDescription2 = `22" x 4" Sidesplash for right wall`;

                                    countertopSinkDescription += `<dd>1 x ${endsplashproductDescription1}</dd>
                                <dd>1 x ${endsplashproductDescription2}</dd>${sinkColorDescriptionHTML}`;
                                    if (endsplashProduct != undefined) {
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "endsplashproduct", "width": VanityConfig.toFraction(element.Width), "description": endsplashproductDescription1, "oedescription": endsplashproductOEDescription1, "productid": endsplashProduct.ProductId, "number": 1 });
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "endsplashproduct", "width": VanityConfig.toFraction(element.Width), "description": endsplashproductDescription2, "oedescription": endsplashproductOEDescription2, "productid": endsplashProduct.ProductId, "number": 1 });
                                    }
                                    break;
                                case "L":
                                    endsplashproductDescription = `22" Side Splash (Left Wall)`;
                                    var endsplashproductOEDescription = `22" x 4" Sidesplash for left wall`;
                                    polishcutproductDescription = `Right-Side Polished Edge (Countertop)`;
                                    var polishcutproductOEDescription = `Right polished edge - eased edge profile`;
                                    countertopSinkDescription += `<dd>1 x ${endsplashproductDescription}</dd>`;
                                    if (endsplashProduct != undefined) {
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "endsplashproduct", "width": VanityConfig.toFraction(element.Width), "description": endsplashproductDescription, "oedescription": endsplashproductOEDescription, "productid": endsplashProduct.ProductId, "number": 1 });
                                    }
                                    if (polishcutProduct != undefined) {
                                        countertopSinkDescription += `<dd>1 x ${polishcutproductDescription}</dd>${sinkColorDescriptionHTML}`;
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "polishcutproduct", "width": VanityConfig.toFraction(element.Width), "description": polishcutproductDescription, "oedescription": polishcutproductOEDescription, "productid": polishcutProduct.ProductId, "number": 1 });
                                    }
                                    break;
                                case "R":
                                    polishcutproductDescription = `Left-Side Polished Edge (Countertop)`;
                                    var polishcutproductOEDescription = `Left polished edge - eased edge profile`;
                                    endsplashproductDescription = `22" Side Splash (Right Wall)`;
                                    var endsplashproductOEDescription = `22" x 4" Sidesplash for right wall`;
                                    countertopSinkDescription += `<dd>1 x ${endsplashproductDescription}</dd>`;
                                    if (polishcutProduct != undefined) {
                                        countertopSinkDescription += `<dd>1 x ${polishcutproductDescription}</dd>${sinkColorDescriptionHTML}`;
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "polishcutproduct", "width": VanityConfig.toFraction(element.Width), "description": polishcutproductDescription, "oedescription": polishcutproductOEDescription, "productid": polishcutProduct.ProductId, "number": 1 });
                                    }
                                    if (endsplashProduct != undefined) {
                                        selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "endsplashproduct", "width": VanityConfig.toFraction(element.Width), "description": endsplashproductDescription, "oedescription": endsplashproductOEDescription, "productid": endsplashProduct.ProductId, "number": 1 });
                                    }
                                    break;
                            }
                        }

                        if (mtk8Product?.ProductId.length > 0) {
                            mtk8ProductDescription = `${mtk8Product?.Description}`;
                            fullAssembledCabinetryDescription += `<dd>1 x ${mtk8ProductDescription}</dd>`;
                        }
                        if (mtk8Product != undefined) {
                            selectedProducts.push({ "wall": `${VanityConfig.storeCustomerSelectedObject.WallLocationAbbr}`, "configid": `${element.ConfigId}`, "type": "mtk8product", "width": VanityConfig.toFraction(element.Width), "description": mtk8ProductDescription, "oedescription": mtk8ProductDescription, "productid": mtk8Product.ProductId, "number": 1 });
                        }
                    }
                });

                let isLoggedIn = VanityConfig.isLoggedIn;
                var vanityBundleImageHTML = `${encodeURIComponent(`
                                <div class="bundle-item-modal">
                                    <div class="vanity-images">
                                        <div style="
                                            display: flex;
                                            flex-direction: column;"
                                            class="vanity-cabinets">
                                                <div
                                                    class="vanity-cabinet-countertop"
                                                    style="${!vanityWithoutTops ? `background-image: url('${VanityConfig.storeCustomerSelectedObject?.CabinetBackgroundImage || ""}')` : ""};
                                                    background-position-x: left;
                                                    background-repeat: repeat-x;
                                                    background-attachment: local;
                                                    width: 100%;
                                                    white-space: nowrap;
                                                    cursor: pointer;
                                                    position: relative;
                                                    display: flex;
                                                    align-items: end;
                                                    box-sizing: border-box;
                                                    padding: 0;
                                                    z-index: 1;
                                                    "
                                                >${cabinetImage}
                                                </div>
                                        </div>                                    
                                    </div>
                                </div>`)}`;
                var vanityPriceHTML = "";
                if (VanityConfig.enableShowPriceSetting) {
                    if (VanityConfig.isVanityAdmin || VanityConfig.showVanityPriceForNonAdmin) {
                        vanityPriceHTML = `<span style="line-height: 1.6; font-size: 1.3rem; font-weight: 100">Bundle Price</span>
                        <div style="display: flex; flex-direction: row; gap: 15px">
                        ${cabinetPrice} 
                        </div>`;
                    }
                } else {
                    vanityPriceHTML = `<span style="line-height: 1.6; font-size: 1.3rem; font-weight: 100">Bundle Price</span>
                        <div style="display: flex; flex-direction: row; gap: 15px">
                        ${cabinetPrice} 
                        </div>`;
                }
                var bundledItemDetails = `${isLoggedIn ? `<div class="price" style="display: flex; flex-direction: column; gap: 0px">
                    <span style="line-height: 1.6;font-size: 1.4rem;font-weight: 600;text-align: center;padding-bottom: 10px;cursor: pointer;color: var(--vanity-label-color);" data-countertop-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.Countertop} ${VanityConfig.storeCustomerSelectedObject.CountertopMaterial} ${VanityConfig.storeCustomerSelectedObject.CountertopLabel} - ${VanityConfig.toFraction(element.CounterTopWidth)}"W x 22"D w/4" Backsplash`)}"
                    data-sink-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.SinkSize} ${VanityConfig.storeCustomerSelectedObject.SinkColor} ${VanityConfig.storeCustomerSelectedObject.SinkFinish} ${VanityConfig.storeCustomerSelectedObject.SinkShape} ${(numOfSinks > 1 ? " Sinks" : " Sink")} (Undermount, ${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread})`)}"
                    data-hardware-description="${encodeURIComponent(`${shopifyProducts.filter(sp => sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel)[0]?.Description ?? ""}`)}"
                    data-dynamicimages="${vanityBundleImageHTML}"
                    data-dh45-100-image="${encodeURIComponent(dh45Product?.Image ?? "")}"
                    onclick="ConfigurationOptions.viewBundleItem('${element.ConfigId}', this)">Click to see full view</span>                    
                    ${vanityPriceHTML}                  
                  </div>`: `<div class="login-to-view-price" style=" display: flex; flex-direction: column; ">
                  <span style="line-height: 1.6;font-size: 1.4rem;font-weight: 600;text-align: center;padding-bottom: 10px;cursor: pointer;color: var(--vanity-label-color);" data-countertop-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.Countertop} ${VanityConfig.storeCustomerSelectedObject.CountertopMaterial} ${VanityConfig.storeCustomerSelectedObject.CountertopLabel} - ${VanityConfig.toFraction(element.CounterTopWidth)}"W x 22"D w/4" Backsplash`)}"
                    data-sink-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.SinkSize} ${VanityConfig.storeCustomerSelectedObject.SinkColor} ${VanityConfig.storeCustomerSelectedObject.SinkFinish} ${VanityConfig.storeCustomerSelectedObject.SinkShape} ${(numOfSinks > 1 ? " Sinks" : " Sink")} (Undermount, ${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread})`)}"
                    data-hardware-description="${encodeURIComponent(`${shopifyProducts.filter(sp => sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel)[0]?.Description ?? ""}`)}"
                    data-dynamicimages="${vanityBundleImageHTML}"
                    data-dh45-100-image="${encodeURIComponent(dh45Product?.Image ?? "")}"
                    onclick="ConfigurationOptions.viewBundleItem('${element.ConfigId}', this)">Click to see full view</span>
                        <a class="login-to-view-price-link" href="${VanityConfig.loginUrl}" title="Login"
                        >Login to view price</a
                        >
                    </div>`}
                  <hr class="line">
                  <dl class="bundle-item-description">
                    ${cabinetDescription}
                    ${fullAssembledCabinetryDescription}
                    ${countertopSinkDescription}
                    ${hardwareDescription}
                    ${VanityConfig.showFreeShipping ? `<dt style="margin-bottom: 0px;padding-bottom: 0px;padding-top: 20px;font-size: 1.6rem;color: #0e6c1d;">Free Shipping</dt>` : ""}
                    <dd style="display: inline-flex;align-items: center; ">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="35px" height="35px" viewBox="0 0 200.000000 200.000000" preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                        <path d="M464 1460 c-28 -11 -36 -34 -19 -57 13 -17 37 -18 384 -21 l371 -3 0 -344 0 -345 -215 0 -216 0 -38 40 c-33 34 -44 40 -80 40 -47 0 -96 -28 -106 -60 -5 -16 -15 -20 -50 -20 -33 0 -47 -5 -54 -18 -16 -30 13 -62 55 -62 27 0 41 -8 64 -34 52 -58 144 -54 185 8 l17 26 294 0 295 0 29 -34 c52 -58 144 -54 185 8 16 23 24 26 80 26 96 0 95 -2 95 207 l0 175 -90 128 c-57 81 -98 130 -112 134 -13 3 -76 6 -140 6 l-118 0 0 89 c0 82 -2 91 -22 105 -19 14 -74 16 -398 15 -206 0 -384 -4 -396 -9z m1106 -365 l51 -75 -171 0 -170 0 0 75 0 75 120 0 119 0 51 -75z m90 -280 l0 -125 -39 0 c-31 0 -41 4 -46 21 -10 29 -64 59 -109 59 -31 0 -45 -7 -78 -40 -31 -31 -48 -40 -74 -40 l-34 0 0 125 0 125 190 0 190 0 0 -125z"/>
                        <path d="M272 1208 c-7 -7 -12 -19 -12 -28 0 -35 21 -40 177 -40 142 0 153 1 163 20 8 14 8 26 0 40 -10 19 -21 20 -163 20 -106 0 -157 -4 -165 -12z"/>
                        <path d="M358 969 c-10 -5 -18 -18 -18 -27 0 -37 19 -42 177 -42 140 0 153 2 163 19 13 25 13 27 -6 45 -13 13 -41 16 -157 16 -78 0 -150 -5 -159 -11z"/>
                        </g>
                    </svg>Ships In 7-10 Business Days
                    </dd>
                  </dl>
                  ${isLoggedIn ? `<button
                    type="button"
                    class="btn btn_outline_oranage_xs"
                    data-dhnumber="${dhNumber}" 
                    data-selectedproductcountertop='${selectedProductCounterTop}' 
                    data-selectedproducts="${encodeURIComponent(JSON.stringify(selectedProducts))}"
                    data-dynamicimages="${vanityBundleImageHTML}"
                    onclick="ConfigurationOptions.addToCart(this)"
                  >
                    Add To Cart
                  </button>`: ""}`;

                let lowPriceHTML = "";
                if (VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage && VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage?.length > 0) {
                    lowPriceHTML = `<div class="tag">
                      <div
                        class="left"
                        style="
                          background-color: unset;
                          padding: 0px;
                        "
                      >
                        <img
                          src="${VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage}"
                          alt="Low Price"
                          loading="lazy"
                          style="max-width:60px;"
                        >
                      </div>
                  </div>`;
                }

                cabinetHTML += `
                <li style="cursor: default;">
                  ${lowPriceHTML}
                  <div class="vanity-images">
                    <div style="
                        display: flex;
                        flex-direction: column;"
                        class="vanity-cabinets">
                            <div
                                onclick="ConfigurationOptions.viewBundleItem('${element.ConfigId}', this)"
                                data-countertop-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.Countertop} ${VanityConfig.storeCustomerSelectedObject.CountertopMaterial} ${VanityConfig.storeCustomerSelectedObject.CountertopLabel} - ${VanityConfig.toFraction(element.CounterTopWidth)}"W x 22"D w/4" Backsplash`)}"
                                data-sink-description="${encodeURIComponent(`${VanityConfig.storeCustomerSelectedObject.SinkSize} ${VanityConfig.storeCustomerSelectedObject.SinkColor} ${VanityConfig.storeCustomerSelectedObject.SinkFinish} ${VanityConfig.storeCustomerSelectedObject.SinkShape} ${(numOfSinks > 1 ? " Sinks" : " Sink")} (Undermount, ${VanityConfig.storeCustomerSelectedObject.DesiredFaucetSpread})`)}"
                                data-hardware-description="${encodeURIComponent(`${shopifyProducts.filter(sp => sp.Model == VanityConfig.storeCustomerSelectedObject.HardwareModel)[0]?.Description ?? ""}`)}"
                                data-dynamicimages="${vanityBundleImageHTML}"
                                data-dh45-100-image="${encodeURIComponent(dh45Product?.Image ?? "")}"
                                class="vanity-cabinet-countertop"
                                style="${!vanityWithoutTops ? `background-image: url('${VanityConfig.storeCustomerSelectedObject?.CabinetBackgroundImage || ""}')` : ""};
                                background-position-x: left;
                                background-repeat: repeat-x;
                                background-attachment: local;
                                width: 100%;
                                white-space: nowrap;
                                cursor: pointer;
                                position: relative;
                                display: flex;
                                align-items: end;
                                box-sizing: border-box;
                                padding: 0;
                                "
                            >${cabinetImage}
                            </div>
                    </div>                    
                  </div>
                  <div class="modal modal-style fade bundle-item-modal"
                        id="bundleItemModal${element.ConfigId}"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="bundleItemModalLabel">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content" style="position: relative;">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" 
                                style="position: fixed; top: 20px; right: 30px; z-index: 1051; background: white; border-radius: 50%; width: 36px; height: 36px; font-size: 24px; border: none;">X</button>
                            </div>
                            <div class="modal-body">
                                <div
                                class="spinner"
                                style="
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                border: 4px solid var(--vanity-main-color);
                                border-left: 4px solid #e3e4e7;
                                animation: vanity_spinner 1.5s linear infinite;
                                margin: 100px auto;
                                "
                              ></div>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="modal modal-style fade quickview-bundle-item-modal"
                        id="quickViewBundleItemModal${element.ConfigId}"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="quickViewBundleItemModalLabel">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">X</button>
                            </div>
                            <div class="modal-body">
                                <div style="display: flex; flex-direction: row; gap: 15px;flex-wrap: wrap;">
                                    <div class="vanity-images" style="flex: 1 1 400px; min-width: 0;display: flex; justify-content: center;">
                                        <div style="
                                            display: flex;
                                            flex-direction: column;"
                                            class="vanity-cabinets">
                                                <div
                                                    class="vanity-cabinet-countertop"
                                                    style="${!vanityWithoutTops ? `background-image: url('${VanityConfig.storeCustomerSelectedObject?.CabinetBackgroundImage || ""}')` : ""};
                                                    background-position-x: left;
                                                    background-repeat: repeat-x;
                                                    background-attachment: local;
                                                    width: 100%;
                                                    white-space: nowrap;
                                                    cursor: pointer;
                                                    position: relative;
                                                    display: flex;
                                                    align-items: end;
                                                    box-sizing: border-box;
                                                    padding: 0;
                                                    z-index: 1;
                                                    "
                                                >${cabinetImage}
                                                </div>
                                        </div>                                    
                                    </div>
                                    <div class="bundle-item-details" style="flex: 1 1 400px; min-width: 0;">
                                        ${bundledItemDetails}
                                    </div>
                                    <style>
  @media (max-width: 991px) {
    .bundle-item-modal-flex.vanity-images-wrapper {
      flex-direction: column !important;
    }
  }
  @media (min-width: 992px) {
    .bundle-item-modal-flex.vanity-images-wrapper {
      flex-direction: row !important;
    }
  }
</style>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                  </div>                  
                  ${bundledItemDetails}
                </li>`;
            });
            var loadMoreHTML = "";
            if (totalPages > VanityConfig.pageNum) {
                var loadMoreHTML = `
                <div class="text-center">
                <button id="loadMoreButton"
                type="button"
                class="btn orange_sm_btn center-block"
                onclick="ConfigurationOptions.loadMoreVanityCabinets()"
              >
                Load More
              </button></div>`;
            }
            cabinetHTML = `<ul class="items">${cabinetHTML}</ul>`;
            if (VanityConfig.pageNum > 1) {
                document.getElementById("loadMoreButton").parentNode.outerHTML = cabinetHTML + loadMoreHTML;
            } else {
                $("#cabinetconfigurations").html(cabinetHTML + loadMoreHTML);
            }
        } else {
            alert("There was a error saving your design. Please try again.");
        }
        $(`.bundle-item-description [data-toggle="popover"]`).popover().mouseover(function (e) {
            $('.side-popover[aria-describedby]').not(this).popover('hide');
            if ($(this).hasClass('side-popover')) {
                if ($('#' + $(this).attr('aria-describedby')).length == 0) {
                    //console.log('show');
                    $(this).popover('show');
                }
            }
        });
        VanityConfig.hideWaiting();

    },
    viewBundleItem: async function (configid, source) {
        var $modal = $("[id='bundleItemModal" + configid + "']");
        $modal.off('show.bs.modal');
        $modal.off('hidden.bs.modal');
        $modal.on('show.bs.modal', async function (event) {
            var countertopDescription = decodeURIComponent($(source).data('countertop-description'));
            var sinkDescription = decodeURIComponent($(source).data('sink-description'));
            var hardwareDescription = decodeURIComponent($(source).data('hardware-description'));
            var hardwarePull = hardwareDescription.replace(/^\d+\s*\d*\/?\d*"\s*/, '').split('Pull')[0] + " Pull"; // Remove leading dimensions like "6 15/16" "
            var dynamicimages = decodeURIComponent($(source).data('dynamicimages'));
            var dh45ProductImage = decodeURIComponent($(source).data('dh45-100-image'));
            var vanityWithoutTops = VanityConfig.enableCountertopWithoutTops && VanityConfig.storeCustomerSelectedObject.CountertopWithoutTops;
            var vanityViewList = [{
                image: dh45ProductImage,
                name: hardwareDescription,
                displayOrder: 4
            },];
            if (!vanityWithoutTops) {
                vanityViewList.push({
                    image: VanityConfig.storeCustomerSelectedObject.CountertopImage,
                    name: countertopDescription,
                    displayOrder: 2,
                    showLowPriceTag: true,
                });
                vanityViewList.push({
                    image: VanityConfig.storeCustomerSelectedObject.SinkShapeImage,
                    name: sinkDescription,
                    displayOrder: 3
                });
            }
            if (VanityConfig.quickviewVideo != undefined && VanityConfig.quickviewVideo.length > 0) {
                vanityViewList.push({
                    image: VanityConfig.quickviewVideoPreviewImage,
                    video: VanityConfig.quickviewVideo,
                    name: "Soft-Close Doors & Drawers",
                    displayOrder: 5
                });
            }
            var postData = {};
            postData.doorStyle = VanityConfig.storeCustomerSelectedObject.DoorStyle;
            if (VanityConfig.siteName != undefined && VanityConfig.siteName.length > 0) {
                postData.siteName = VanityConfig.siteName;
            }
            if (dynamicimages != undefined && dynamicimages.length > 0) {
                postData.html = dynamicimages;
                const vanityHtmlToImageQuery = await ConfigurationOptions.postDataApi(VanityConfig.htmlToImageSource, postData);
                const vanityHtmlToImageData = vanityHtmlToImageQuery?.Data || [];
                if (vanityHtmlToImageData) {
                    const vanityHtmlToImage = vanityHtmlToImageData?.image ?? '';
                    if (vanityHtmlToImage && vanityHtmlToImage.length > 0) {
                        vanityViewList.push({
                            image: vanityHtmlToImage,
                            name: "Custom Vanity Bundle Overview",
                            note: `Please note: Decorative hardware is included but ships separately (not pre-installed). Shown with ${hardwarePull}`,
                            displayOrder: 1,
                            showLowPriceTag: true,
                        });
                    }
                }
            }
            vanityViewList.sort((a, b) => a.displayOrder - b.displayOrder);

            let lowPriceHTML = "";
            if (VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage
                && VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage?.length > 0) {
                lowPriceHTML = `<div class="tag"  style="position: absolute; top: 1px; left: 1px;  ">
                      <div
                        class="left"
                        style="
                          background-color: unset;
                          padding: 0px;
                          width:80px;
                        "
                      >
                        <img
                          src="${VanityConfig.storeCustomerSelectedObject?.CountertopLowPriceImage}"
                          alt="Low Price"
                          loading="lazy"
              style="width: 100%; height: auto;"
                        >
                      </div>
                  </div>`;
            }

            let defaultTitle = "";
            var vanityViewHTML = `
            <div class="vanity-view">
                <div id="vanity-bundle-view-carousel" class="carousel slide" data-ride="carousel" aria-labelledby="collection_images_list">
                    <ol class="carousel-indicators">
                    ${vanityViewList.map((item, index) => {
                return `<li
                        data-target="#vanity-bundle-view-carousel"
                        data-slide-to="${index}"
                        class="${index === 0 ? 'active' : ''}"
                        >
                        <img  data-toggle="tooltip" 
                            data-placement="right" 
                            style="${index === 0 ? "object-fit: contain;" : ""}"
                            title="${item.name.replace(/"/g, '&quot;')}"
                            class="img-responsive center-block"
                            src="${item.image}"
                            alt="image${index}"
                            width="80"
                            height="80" 
                            ${index != 0 ? 'loading="lazy"' : ''}
                        >
                        </li>`;
            }).join('')}
                    </ol>
                    <div id="vanity-bundle-view-carousel-contents" class="carousel-inner">
                    ${vanityViewList.map((item, index) => {
                let title = item.name;
                if (item?.note != undefined && item?.note.length > 0) {
                    title += `<br/><span style=" font-size: 13px; ">${item.note}</span>`;
                }
                if (index === 0) {
                    defaultTitle = title;
                }
                return `<div class="item ${(item.video == undefined || VanityConfig.quickviewVideo.length == 0) ? `image-item` : `video-item`}  ${index === 0 ? 'active' : ''}" 
                                    data-title="${encodeURIComponent(title)}">
                                    ${item.showLowPriceTag ? lowPriceHTML : ''}
                                    ${(item.video == undefined || VanityConfig.quickviewVideo.length == 0) ? `<img
                                    class="img-responsive center-block ${index === 0 ? 'vanity-bundle' : ''}"
                                    src="${item.image}"
                                    alt="image${index}"
                                    width="860"
                                    height="730"
                                    style="${index === 0 ? "object-fit: contain;" : ""}"
                                    ${index != 0 ? '' : 'loading="lazy"'}                
                                >`: `<div class="video embed-responsive embed-responsive-4by3" style=" position: unset; ">
                                        <video controls loop>
                                        <source
                                        src="${item.video}"
                                        type="video/mp4"
                                        >
                                        </video>
                                    </div>`}
                                
                                </div>`;
            }).join('')}     
                    </div>
                </div>
                <label id="vanity-bundle-view-carousel-label">${defaultTitle}</label>
            </div>`;
            $(this).find('.modal-body').html(vanityViewHTML);
            $("#vanity-bundle-view-carousel").on("slide.bs.carousel", function (e) {
                var source = e.relatedTarget;
                $("#vanity-bundle-view-carousel-label").html(decodeURIComponent($(source).data('title')) || "Custom Vanity Bundle Overview");
            });
            event.stopPropagation();
        }).on('hidden.bs.modal', function (event) {
            $(this).find('.modal-body').html(`
            <div
                class="spinner"
                style="
                width: 60px;
                height: 60px;
                border-radius: 50%;
                border: 4px solid var(--vanity-main-color);
                border-left: 4px solid #e3e4e7;
                animation: vanity_spinner 1.5s linear infinite;
                margin: 100px auto;
                "
            ></div>`);
            event.stopPropagation();
        }).modal('show');
    },
    quickViewBundleItem: function (configid) {
        $("#quickViewBundleItemModal" + configid).modal('show');
    },
    loadMoreVanityCabinets: async function () {
        VanityConfig.showWaiting();
        VanityConfig.pageNum++;
        await this.cabinetConfigurations();
        VanityConfig.hideWaiting();
    },
    leftFilterMenu: async function (source) {
        //var vanityList = VanityConfig.vanityWidthSource.filter(vw => source.find((s) => s.configid == vw.configid));
        // var vanityOptionList = VanityConfig.vanityOptionSource.filter(vo => source.find((s) => s.ConfigId == vo.configid));     
        var vanityOptionList = [];
        source.forEach((element) => {
            element.Options.forEach((vco) => {
                if ((vanityOptionList.filter(vo => vo.ConfigId == element.ConfigId && vo.CabinetWidth == vco.CabinetWidth) || []).length <= 0) {
                    const currentOption =
                    {
                        ConfigId: element.ConfigId,
                        Model: vco.Model,
                        CabinetWidth: vco.CabinetWidth,
                    };
                    vanityOptionList.push(currentOption);
                }
            });
        });
        //#region LeftMenu In Vanity
        function LeftMenuInVanity(source, menuLabel, hasCheckbox, filterType, groupBy, symbol) {
            var leftmenuHTML = "";
            var vanityList = Object.groupBy(source, groupBy);
            if (Object.values(vanityList).length > 0) {
                for (const [key, value] of Object.entries(vanityList).toSorted()) {
                    var checkedMarkup = "";
                    if (VanityConfig.storeCustomerSelectedObject.Filters != undefined
                        && VanityConfig.storeCustomerSelectedObject.Filters.length > 0) {
                        var filterList = Object.groupBy(VanityConfig.storeCustomerSelectedObject.Filters, ({ Type }) => Type);
                        for (const [filterKey, filterValue] of Object.entries(filterList).toSorted()) {
                            if (filterKey == filterType && filterValue.find((fv) => fv.Value == key)) {
                                checkedMarkup = `checked="checked"`;
                            }
                        }
                    }
                    leftmenuHTML += `
                    <li class="filter-li-item configuration-options-filters ${!hasCheckbox ? "filter_width" : ""} ${checkedMarkup.length > 0 ? "checked" : ""}" ${checkedMarkup} id="filter_NumberOfSinks_2" onclick="ConfigurationOptions.applyFilter(this)">
                        <div class="checkbox">
                            ${hasCheckbox ? `<input type="checkbox" style="pointer-events: none;" name="checkbox" id="checkbox-${filterType}-${key}" ${checkedMarkup} data-type="${filterType}" data-text="${menuLabel}" data-value="${key}">
                            <label for="checkbox-${filterType}-${key}">
                            <span class="filter-item-span darkred boldspan">${VanityConfig.toFraction(parseFloat(key))}${(symbol || false) ? "\"" : ""} (${value.length})</span>
                            </label>`: `<span class="filter-item-span" data-type="${filterType}" data-text="${menuLabel}" data-value="${key}">${VanityConfig.toFraction(parseFloat(key))}${(symbol || false) ? "\"" : ""} (${value.length})</span>`}                           
                        </div>
                    </li>`;
                    // leftmenuHTML += `
                    // <tr>
                    //     <td valign="bottom">
                    //         <div style="float:left;">
                    //             <input type="checkbox" onclick="Cabinetlayout.applyFilter()" class="vanityfilters" ${checkedMarkup} data-type="${filterType}" data-value="${key}" style="cursor:pointer;" />
                    //         </div>
                    //         <div style="float:left;">
                    //             &nbsp;${VanityConfig.toFraction(parseFloat(key))}${(symbol || false) ? "\"" : ""} (${value.length})
                    //         </div>
                    //     </td>
                    // </tr>`;
                }
                leftmenuHTML = `
                <div class="filter panel">
                    <h4 class="left-items-title">
                    <a
                        id="acollapseFitler-${filterType}"
                        data-toggle="collapse"
                        data-parent="#cabinets-filters"
                        aria-expanded="true"
                        data-target="#collapseFitler-${filterType}"
                        aria-controls="collapseFitler-${filterType}"
                    >
                        ${menuLabel}
                        <div class="arrows_wrap visible-xs-block visible-sm-block">
                        <div class="arrow"></div>
                        </div>
                    </a>
                    </h4>
                    <div class="collapse" id="collapseFitler-${filterType}" aria-expanded="true">
                    <ul class="left-items">
                        ${leftmenuHTML}
                    </ul>
                    </div>
                </div>`;
                // leftmenuHTML = `<tr>
                //                 <td valign="top">
                //                     <table cellspacing="0" cellpadding="0" class="div_options">
                //                         <tr>
                //                             <td style="font-weight:bold; font-size:14px;">
                //                                 ${menuLabel}
                //                             </td>
                //                         </tr>
                //                         ${leftmenuHTML}
                //                     </table>
                //                 </td>
                //             </tr>`;
            }
            return leftmenuHTML;
        }
        //#endregion

        //#region Left Menu
        var leftMenuHTML = `        
            ${LeftMenuInVanity(source, "Number Of Sinks", true, "numofsinks", ({ NumOfSinks }) => NumOfSinks)}
            ${LeftMenuInVanity(source, "Number Of Tall Cabinets", true, "numtalls", ({ NumTalls }) => NumTalls)}
            ${LeftMenuInVanity(source, "Number Of Drawer Bases", true, "numdrawerbases", ({ NumDrawerBases }) => NumDrawerBases)}
            ${LeftMenuInVanity(source, "Number Of Desk Cabinets", true, "numdesks", ({ NumDesks }) => NumDesks)}            
            ${LeftMenuInVanity(source, "Countertop Width", false, "countertopwidth", ({ CounterTopWidth }) => CounterTopWidth, true)}
            `;
        // ${LeftMenuInVanity(vanityOptionList, "Cabinet Width", "cabinetwidth", ({ CabinetWidth }) => CabinetWidth, true)}
        $("#left-filters-menus").html(leftMenuHTML);
        this.filterOverview();
        document.querySelectorAll("a[id*=acollapseFitler-]").forEach(el => {
            el.addEventListener('click', function (event) {
                var currentElement = $(event.currentTarget);
                if (currentElement.hasClass('collapsed')) {
                    currentElement.find('.arrow').css({ 'transform': 'rotate(315deg)' });
                    $('#cabinets-filters a[id^="acollapseFitler-"]:not(".collapsed")').each(function () {
                        var _item = $(this);
                        $($(this).attr('data-target')).slideUp(300, function () {
                            $(this).removeClass('in').removeAttr('style');
                            _item.addClass('collapsed');
                            _item.find('.arrow').css({ 'transform': 'rotate(135deg)' });
                        });
                    });
                }
                else {
                    currentElement.find('.arrow').css({ 'transform': 'rotate(135deg)' });
                }
            });
        });
        //#endregion
    },
    applyFilter: async function (target) {
        VanityConfig.showWaiting();
        VanityConfig.pageNum = 1;

        if ($(target).hasClass("checked")) {
            var hasCheckbox = ($(target).find("input[type*=checkbox]") || "").length > 0;
            var selectedElement = {};
            if (hasCheckbox) {
                $(target).find("input[type*=checkbox]").prop("checked", "checked");
                selectedElement = $(target).find("input[type*=checkbox]:checked");
            } else {
                selectedElement = $(target).find("span");
            }
            var type = selectedElement.data("type");
            var value = selectedElement.data("value");
            var text = selectedElement.data("text");
            await this.removeFilterItem($(`#filters-overview button[type*=button][data-type='${type}'][data-value='${value}']`));
        } else {
            target.setAttribute("checked", "checked");
        }

        var filters = $("li[class*='configuration-options-filters'][checked='checked']").map((index, element) => {
            var hasCheckbox = ($(element).find("input[type*=checkbox]") || "").length > 0;
            var selectedElement = {};
            if (hasCheckbox) {
                $(element).find("input[type*=checkbox]").prop("checked", "checked");
                selectedElement = $(element).find("input[type*=checkbox]:checked");
            } else {
                selectedElement = $(element).find("span");
            }
            var type = selectedElement.data("type");
            var value = selectedElement.data("value");
            var text = selectedElement.data("text");
            return { "Type": type, "Value": value, "Text": text };
        });
        VanityConfig.storeCustomerSelectedObject.Filters = filters.toArray();
        localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        this.filterOverview();
        $("#cabinets-filters").addClass("hidden-cabinet-layout-filters");
        $("#cabinets-filters").removeClass("cabinet-layout-filters");
        document.querySelector("body").style.removeProperty("overflow");
        document.querySelector("#cabinets-filters").style.removeProperty("overflow");
        document.querySelector("#left-filters-menus").style.removeProperty("overflow");
        document.querySelector("#left-filters-menus").style.removeProperty("height");
        VanityConfig.SetTopChoices();
        await this.cabinetConfigurations();
        VanityConfig.hideWaiting();
    },
    filterOverview: function () {
        var filterOverviewHTML = "";
        if (VanityConfig.storeCustomerSelectedObject.Filters != undefined
            && VanityConfig.storeCustomerSelectedObject.Filters.length > 0) {
            var filterList = Object.groupBy(VanityConfig.storeCustomerSelectedObject.Filters, ({ Type }) => Type);
            for (const [key, value] of Object.entries(filterList).toSorted()) {
                value.forEach((element) => {
                    filterOverviewHTML += `
                    <button
                        type="button"
                        class="btn btn_outline_gray btn-filter-remove"
                        onclick="ConfigurationOptions.removeFilterItem(this);return false;"
                        data-type="${element.Type}" data-text="${element.Text}" data-value="${element.Value}"
                        >
                        <span class="close_btn">X</span>${element.Text}: ${element.Value}
                    </button>`;

                });
            }
        }
        if (filterOverviewHTML.length > 0) {
            filterOverviewHTML = `${filterOverviewHTML}
                <a class="clear_all" href="javascript:void(0)" onclick="ConfigurationOptions.removeFilters();return false;">Clear All Filters</a>`;
        }
        $("#filters-overview").html(filterOverviewHTML);
    },
    removeFilterItem: async function (target) {
        VanityConfig.showWaiting();
        VanityConfig.pageNum = 1;
        var type = $(target).data("type");
        var value = $(target).data("value");
        var text = $(target).data("text");
        if (VanityConfig.storeCustomerSelectedObject.Filters != undefined
            && VanityConfig.storeCustomerSelectedObject.Filters.length > 0) {
            var removedFilters = VanityConfig.storeCustomerSelectedObject.Filters.filter((f) => {
                if (f.Type === type && f.Value === value) return false;
                return true;
            });
            VanityConfig.storeCustomerSelectedObject.Filters = removedFilters;
            localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
            await this.cabinetConfigurations();
        }
        VanityConfig.hideWaiting();
    },
    removeFilters: async function (target) {
        VanityConfig.showWaiting();
        VanityConfig.pageNum = 1;
        VanityConfig.storeCustomerSelectedObject.Filters = [];
        localStorage.setItem(VanityConfig.storeCustomerSelectedKey, JSON.stringify(VanityConfig.storeCustomerSelectedObject));
        await this.cabinetConfigurations();
        VanityConfig.hideWaiting();
    },
    postDataApi: async function (url = '', formData) {
        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify(formData), // body data type must match "Content-Type" header
        });
        return response.json();
    },
    addItem: async function (data = {}) {
        const result = await fetch('/cart/add.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(data)
        });
        return result;
    },
    formatAttribute: function (val) {
        if (val == null || typeof (val) == 'undefined') return '';
        return val.replaceAll('[-split1-]', ':')
            .replaceAll('[-split2-]', '"');
    },
    addToCart: async function (obj) {
        VanityConfig.showWaiting();
        var selectedproducts = decodeURIComponent($(obj).data("selectedproducts"));
        var selecteddynamicimages = decodeURIComponent($(obj).data("dynamicimages"));
        if (VanityConfig.showLogoConfiguredBundleImage != undefined && VanityConfig.showLogoConfiguredBundleImage) {
            selecteddynamicimages = "";
        }
        var postData = {};
        postData.doorStyle = VanityConfig.storeCustomerSelectedObject.DoorStyle;
        if (VanityConfig.siteName && VanityConfig.siteName.length > 0) {
            postData.siteName = VanityConfig.siteName;
        }
        postData.productName = `${VanityConfig.storeCustomerSelectedObject.DoorStyleFullName} Custom Bath Cabinetry Bundle`;
        postData.products = JSON.stringify(JSON.parse(selectedproducts));
        postData.dynamicImagesHTML = selecteddynamicimages;
        postData.showLogoConfiguredBundleImage = VanityConfig.showLogoConfiguredBundleImage;
        postData.bundleId = VanityConfig.CollectionBundleId;
        if (VanityConfig.enableB2BPrice) {
            postData.companyLocationId = VanityConfig.companyLocationId;
        }
        var products = await this.postDataApi(VanityConfig.createProductBundles, postData)
            .catch((error) => {
                console.log(error);
            });
        try {
            var productData = products.Data;
            if (productData.success) {
                var productId = productData.productid;
                var variantId = productData.variantid;

                var addedProucut = JSON.parse(selectedproducts);
                var filteredProduct = addedProucut.filter(ap => ap.type == "product");

                const productPLYSides = this.getCabinetSideSkins(filteredProduct,
                    VanityConfig.storeCustomerSelectedObject.WallLocationAbbr,
                    "PLY",
                    VanityConfig.storeCustomerSelectedObject.CollectionColorFinish);

                const productEWSides = this.getCabinetSideSkins(filteredProduct,
                    VanityConfig.storeCustomerSelectedObject.WallLocationAbbr,
                    "EW",
                    VanityConfig.storeCustomerSelectedObject.CollectionColorFinish);

                const vanityPLYBundle = addedProucut.map(ap => {
                    const productid = ap.productid;
                    const plySideSkin = productPLYSides.find(pl => pl.productid == productid);
                    if (plySideSkin) {
                        const leftSide = plySideSkin.left || false;
                        const rightSide = plySideSkin.right || false;
                        const bothSides = leftSide && rightSide;
                        const noneSide = !leftSide && !rightSide;
                        const product = ap.product || {};

                        let variant = null;

                        if (product != undefined && !_.isEmpty(product)) {
                            let plyVariant = product.Variants.filter(v => v.Material.toUpperCase() == "PLYWOOD");

                            if (!plyVariant || _.isEmpty(plyVariant)) {
                                plyVariant = product.Variants;//dkd30
                            }
                            variant = plyVariant[0];
                        }

                        return {
                            ..._.omit(ap, ["variantdescription", "product"]),
                            "description": `${product?.Description}`,
                            "material": "PLY",
                            "leftSide": leftSide,
                            "rightSide": rightSide,
                            "bothSides": bothSides,
                            "noneSide": noneSide,
                            variantid: variant?.VariantId || "",
                        };
                    }

                    return ap;
                });

                const vanityEWBundle = addedProucut.map(ap => {
                    const productid = ap.productid;
                    const ewSideSkin = productEWSides.find(ew => ew.productid == productid);
                    if (ewSideSkin) {
                        const leftSide = ewSideSkin.left || false;
                        const rightSide = ewSideSkin.right || false;
                        const bothSides = leftSide && rightSide;
                        const noneSide = !leftSide && !rightSide;
                        const product = ap.product || {};

                        let variant = null;

                        var skinned = "";

                        if (product != undefined && !_.isEmpty(product)) {
                            var ewVariant = product.Variants.filter(v => v.Material.toUpperCase() == "EW");

                            if (bothSides) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "BOTH");
                                skinned = "- Skinned Both"
                            } else if (leftSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "LEFT");
                                skinned = "- Skinned Left"
                            } else if (rightSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "RIGHT");
                                skinned = "- Skinned Right"
                            } else if (noneSide) {
                                ewVariant = ewVariant.filter(v => v.Side.toUpperCase() == "NO");
                            }
                            if (!ewVariant || _.isEmpty(ewVariant)) {
                                ewVariant = product.Variants;//dkd30
                            }

                            variant = ewVariant[0];

                            let variantDescription = null;
                            const tempDescription = variant?.Description || "";
                            if (!_.isEmpty(tempDescription)) {
                                if (bothSides) {
                                    variantDescription = `${tempDescription} - Both`;
                                } else if (leftSide) {
                                    variantDescription = `${tempDescription} - Left`;
                                } else if (rightSide) {
                                    variantDescription = `${tempDescription} - Right`;
                                }
                            }

                            return {
                                ..._.omit(ap, ["variantdescription", "product"]),
                                "description": `${product?.Description} ${skinned}`,
                                "material": "EW",
                                "leftSide": leftSide,
                                "rightSide": rightSide,
                                "bothSides": bothSides,
                                "noneSide": noneSide,
                                variantid: variant?.VariantId || "",
                                ...(variantDescription && { "variantdescription": variantDescription || "", }),
                            };
                        }
                    }

                    return ap;
                });

                var shopifyProperties = {};
                shopifyProperties._ideal_product_program = "Assembled";
                shopifyProperties._ideal_doorstyle = VanityConfig.storeCustomerSelectedObject.DoorStyle;
                shopifyProperties._ideal_collection_handle = VanityConfig.storeCustomerSelectedObject.DoorStyleHandle;
                postData.products = JSON.stringify(vanityPLYBundle);
                shopifyProperties._ideal_vanity_ply_bundle = JSON.stringify(postData);
                postData.products = JSON.stringify(vanityEWBundle);
                shopifyProperties._ideal_vanity_ew_bundle = JSON.stringify(postData);
                shopifyProperties._ideal_vanity_material = VanityConfig.storeCustomerSelectedObject.BoxMaterial;
                shopifyProperties._default_variant_id = variantId.replace("gid://shopify/ProductVariant/", "");

                if (VanityConfig.enableB2BPrice && VanityConfig.enableB2BPrice == true) {
                    shopifyProperties._custnum = custNum;
                    shopifyProperties._freight_rule = this.formatAttribute(freight_rule);
                }
                if (variantId.length > 0) {
                    var addItemsToShopify = {};
                    var addItems = [];
                    var addItemsObject =
                    {
                        id: variantId.replace("gid://shopify/ProductVariant/", ""),
                        quantity: 1,
                        properties: shopifyProperties
                    };
                    addItems.push(addItemsObject);
                    addItemsToShopify.items = addItems;
                    var addCarts = await this.addItem(addItemsToShopify)
                        .then(response => {
                            if (response.status === 200) {
                                return response.json();
                            }
                        })
                        .then(async (response) => {
                            VanityConfig.showWaiting();
                            // window.location.href = "/cart";
                            setTimeout(function () {
                                window.location.href = '/cart';
                                VanityConfig.hideWaiting();
                            }, 3000);
                        })
                        .catch((error) => {
                            console.log(error);
                            VanityConfig.hideWaiting();
                        });
                } else {
                    alert("There was a error adding to cart. Please try again.");
                    VanityConfig.hideWaiting();
                }
            } else {
                alert(productData.msg);
                VanityConfig.hideWaiting();
            }
        } catch {
            alert("There was a error adding to cart. Please try again.");
            VanityConfig.hideWaiting();
        }
    }
}